{
  "accept_invitation": {
    "account_exists": {
      "description_prefix": "An account with",
      "description_suffix": "already exists. Please log in to accept the invitation.",
      "title": "Account Exists"
    },
    "actions": {
      "create_and_accept": "Create Account & Accept",
      "creating_account": "Creating Account...",
      "go_to_login": "Go to Login",
      "login_to_accept": "Log In to Accept"
    },
    "errors": {
      "accept_failed": "Failed to accept invitation",
      "all_fields_required": "All fields are required",
      "invalid_link": "Invalid invitation link",
      "password_min_length": "Password must be at least 8 characters long",
      "verify_failed": "Failed to verify invitation"
    },
    "form": {
      "first_name": "First Name",
      "last_name": "Last Name",
      "new_account_needed": "New account needed. Please provide your details.",
      "password": "Password",
      "subtitle": "Complete your registration to join the organization",
      "title": "Accept Invitation",
      "username_note": "Your username will be auto-generated based on your name."
    },
    "invalid": {
      "title": "Invalid Invitation"
    },
    "joining": {
      "adding_you_to": "Adding you to",
      "title": "Joining Organization"
    },
    "loading": {
      "verify_invitation": "Verifying your invitation..."
    }
  },
  "account": {
    "notifications": {
      "daily_usage_digest": "Daily usage digest",
      "daily_usage_digest_desc": "Receive a daily email summary of AI usage and wallet balance (requires email notifications)."
    }
  },
  "activity_logs": {
    "action": "Action",
    "card_description": "All user and system activities are listed below.",
    "card_title": "Logs",
    "count_one": "{{count}} Activities Total",
    "count_other": "{{count}} Activities Total",
    "create_index_link": "Create index in Firebase Console",
    "date": "Date",
    "description": "View all system activity and audit logs.",
    "details": "Details",
    "filters": {
      "all_actions": "All Actions"
    },
    "headers": {
      "action": "Action",
      "details": "Details",
      "timestamp": "Timestamp",
      "user": "User"
    },
    "no_logs_desc": "There are no recorded events for this user in the specified period.",
    "recent_events": "Recent Events",
    "retry_instruction": "(then retry below).",
    "search_placeholder": "Search logs...",
    "title": "Activity Logs"
  },
  "admin_dashboard": {
    "organizations": {
      "active_orgs": "Active Builders",
      "desc": "Overview of builder statistics and management.",
      "manage_btn": "Manage Builders",
      "new_orgs_week": "new builders this week",
      "title": "Builders",
      "total_orgs": "Total Builders"
    },
    "rbac": {
      "active_assignments": "Active Assignments",
      "desc": "Overview of roles, permissions, and access control.",
      "manage_roles_btn": "Manage Roles",
      "new_assignments": "assignments",
      "title": "Role-Based Access Control",
      "total_permissions": "Total Permissions",
      "total_roles": "Total Roles",
      "view_perms_btn": "View Permissions"
    },
    "user_management": {
      "active_users": "Active Users",
      "desc": "Overview of user statistics and management.",
      "manage_btn": "Manage Users",
      "new_users_week": "new users this week",
      "title": "User Management",
      "total_users": "Total Users"
    }
  },
  "admin_subs": {
    "description": "Monitor and manage all subscriptions across the platform",
    "headers": {
      "auto_renew": "Auto Renew",
      "end_date": "End Date",
      "organization": "Organization",
      "plan": "Plan",
      "price": "Price",
      "start_date": "Start Date",
      "stripe_id": "Stripe ID",
      "user": "User"
    },
    "stats": {
      "active_subscriptions": "Active Subscriptions",
      "monthly_revenue": "Monthly Revenue",
      "total_subscriptions": "Total Subscriptions"
    },
    "table": {
      "description": "Detailed view of all subscriptions with filtering and search capabilities",
      "title": "All Subscriptions"
    },
    "title": "Manage All Subscriptions"
  },
  "admin_user_detail": {
    "actions": {
      "edit_identifier": "Edit Identifier",
      "reset_password": "Reset Password",
      "return_dashboard": "Return to Dashboard",
      "return_org_users": "Return to Org Users"
    },
    "activity": {
      "description": "Chronological record of account and system events.",
      "empty": "No activity captured.",
      "system_event": "System event triggered.",
      "title": "Activity Log"
    },
    "errors": {
      "access_denied": "Access Denied",
      "identity_not_found": "The requested identity could not be located.",
      "load_user_failed": "Failed to load user details.",
      "transmission_failed": "Transmission failed",
      "update_status_failed": "Failed to update status"
    },
    "labels": {
      "organization_users": "Organization Users",
      "system_users": "System Users"
    },
    "loading_profile": "Loading User Profile",
    "organizations": {
      "description": "List of organizations this user is affiliated with.",
      "independent_user": "Independent User (No Org Affiliations)",
      "title": "Organization Memberships"
    },
    "profile": {
      "access_enabled": "User has platform access",
      "access_restricted": "Access is restricted",
      "account_status": "Account Status",
      "active_status": "Active Status",
      "awaiting_verification": "Awaiting verification",
      "billing_wallet": "Billing & Wallet",
      "email": "Email",
      "email_notifications": "Email Notifications",
      "email_verified": "Email Verified",
      "identity_confirmed": "Identity confirmed",
      "in_app_notifications": "In-App Notifications",
      "info": "Profile Information",
      "language": "Language",
      "last_login": "Last Login",
      "member_since": "Member Since",
      "never": "Never",
      "notifications": "Notifications",
      "phone": "Phone",
      "username": "Username"
    },
    "roles_tab": {
      "assigned_roles": "Assigned Roles",
      "description": "Current permissions and access levels assigned to this user.",
      "direct_role": "Directly Assigned Role",
      "global_access": "Global Access",
      "organization_scoped": "Organization Scoped",
      "platform_wide_role": "Platform-wide Role",
      "total_one": "{{count}} Total",
      "total_other": "{{count}} Total"
    },
    "tabs": {
      "activity": "Activity",
      "organizations": "Organizations",
      "profile": "Profile",
      "roles": "Roles",
      "usage": "Usage & Credits"
    },
    "toasts": {
      "recovery_initiated": "Recovery transmission initiated",
      "user_activated": "User activated successfully",
      "user_deactivated": "User deactivated successfully"
    },
    "usage": {
      "amount_inr": "Amount (INR)",
      "amount_placeholder": "0.00",
      "amount_usd": "Amount (USD)",
      "credits_added_to": "Credits will be added to",
      "current_balance": "Current Balance",
      "description": "Description",
      "description_placeholder": "Purpose (e.g., Refund, Bonus)",
      "errors": {
        "grant_failed": "Failed to grant credits"
      },
      "grant_credits": "Grant Credits",
      "grant_org": "Grant to Org Wallet",
      "grant_org_desc": "Add credits to the organization's shared wallet.",
      "grant_personal": "Grant to Personal Wallet",
      "grant_personal_desc": "Add usage credits to this user's account.",
      "lifetime_credits": "Lifetime Credits",
      "lifetime_usage": "Lifetime Usage",
      "no_transactions": "No transactions recorded.",
      "org_wallet": "org wallet",
      "toast": {
        "org_granted": "{{amount}} credits granted to {{orgName}} org wallet",
        "personal_granted": "{{amount}} credits granted to personal wallet"
      },
      "transaction_history": "Transaction History",
      "transaction_history_desc": "History of all balance and usage changes."
    }
  },
  "admin_users": {
    "access_denied": {
      "description": "You don't have the required permissions to view user management.",
      "title": "Access Denied"
    },
    "add_user": "Add User",
    "billing_country": "Billing country",
    "billing_country_locked": "Billing country cannot be changed after the wallet currency is locked.",
    "billing_country_super_admin_only": "Only super admins can change billing country.",
    "bulk_actions": {
      "activate": "Activate",
      "activate_now": "Activate Users",
      "confirm_activate": "Are you sure you want to activate the selected users?",
      "confirm_deactivate": "Are you sure you want to deactivate the selected users?",
      "confirm_reset_password": "Are you sure you want to send password reset links to the selected users?",
      "deactivate": "Deactivate",
      "deactivate_now": "Deactivate Users",
      "description": "Choose an action to apply to all selected participants.",
      "export": "Export CSV",
      "grant_button": "Grant Credits Now",
      "grant_credits": "Grant Credits",
      "grant_credits_failed": "Failed to grant credits to some users.",
      "grant_to_multiple": "Grant credits to multiple users at once.",
      "reset_password": "Send Reset Links",
      "reset_password_success": "admin_users.bulk_actions.reset_password_success",
      "selected": "Users Selected",
      "selected_users": "Users Selected",
      "send_now": "Send Links Now",
      "users_affected": "Users will be affected"
    },
    "cannot_deactivate_self": "Cannot deactivate your own account.",
    "card": {
      "description": "A list of all users in your system.",
      "title": "All Users"
    },
    "edit_user": "Edit Participant",
    "email_reset": "Email Reset Link",
    "email_reset_desc": "Standard flow via user email",
    "errors": {
      "fetch_failed": "Failed to fetch users or roles.",
      "no_users": "admin_users.errors.no_users"
    },
    "filters": {
      "all": "admin_users.filters.all",
      "all_roles": "All Roles",
      "all_status": "All Status"
    },
    "invalid_amount": "Please enter a valid amount.",
    "list_description": "A centralized list of all registered accounts and their access levels.",
    "pagination_info": "Showing {{start}} to {{end}} of {{total}} participants",
    "pending": {
      "aadhaar": "Aadhaar pending",
      "all_complete": "Complete",
      "country": "No country",
      "email": "Email unverified",
      "phone": "No phone"
    },
    "search_placeholder": "Search users...",
    "sections": {
      "access": "Access & Identity",
      "billing": "Billing & Wallet",
      "personal": "Personal Profile",
      "preferences": "System Preferences",
      "security": "Security Management"
    },
    "send_link": "Send Link",
    "set_password": "Administrative Password Reset",
    "status_modal": {
      "activate_desc": "Confirm account activation for",
      "activate_title": "Activate Account",
      "activate_warning": "Activating this account will restore all platform privileges immediately.",
      "deactivate_desc": "Confirm account deactivation for",
      "deactivate_title": "Deactivate Account",
      "deactivate_warning": "Deactivating this account will immediately revoke all platform access until reactivated."
    },
    "status_update_failed": "Failed to update user status",
    "subtitle": "Manage your organization's users.",
    "system_participants": "System Participants",
    "table": {
      "aadhaar": "Aadhaar",
      "aadhaar_last_four": "Aadhaar ending in {{lastFour}}",
      "aadhaar_not_verified": "Not verified",
      "aadhaar_verified": "Verified",
      "actions": "Actions",
      "country_currency": "Country & Currency",
      "created": "Created",
      "email_verified": "Email Verification",
      "id": "ID",
      "member_since": "Member Since",
      "name": "Name",
      "roles": "Roles",
      "status": "Status",
      "view_usage": "View usage"
    },
    "title": "Users",
    "total_users": "Users Total",
    "unverification_success": "",
    "usage_sheet": {
      "amount": "Amount",
      "amount_inr": "Amount (INR)",
      "amount_usd": "Amount (USD)",
      "date": "Date",
      "description": "Description (optional)",
      "description_placeholder": "e.g. Promo credits",
      "grant_button": "Grant credits",
      "grant_credits": "Grant credits",
      "grant_org_button": "Grant to Org Wallet",
      "grant_success": "Credits granted successfully!",
      "ledger": "Recent ledger",
      "no_entries": "No ledger entries yet.",
      "org_wallet": "Org",
      "personal_balance": "Personal Wallet Balance",
      "personal_wallet": "Personal Wallet",
      "select_wallet_label": "Select Wallet to View & Grant:",
      "title": "Credits & Usage",
      "type": "Type"
    },
    "user_activated": "User account activated",
    "user_deactivated": "User account deactivated",
    "verification_error": "Failed to update verification status",
    "verification_success": "",
    "verify_desc": "Manual override for email verification status",
    "wallet_currency": "Wallet currency",
    "wallet_currency_locked": "Locked after first wallet activity",
    "wallet_currency_pending": "Not locked yet — set country before top-up or usage"
  },
  "analytics": {
    "actions": {
      "export_data": "Export Data",
      "view_detailed_report": "View Detailed Report",
      "view_system_logs": "View System Logs"
    },
    "activity": {
      "desc_super_admin": "Latest updates from across the ecosystem.",
      "desc_user": "Most viewed properties this month.",
      "title_super_admin": "Platform Activity",
      "title_user": "Top Performing Listings"
    },
    "charts": {
      "engagement_overview": "Engagement Overview",
      "engagement_overview_desc": "Daily views and inquiries across all properties.",
      "growth_revenue": "Growth & Revenue",
      "growth_revenue_desc": "Monthly recurring revenue and user acquisition trends."
    },
    "description_super_admin": "Monitor platform health, user growth, and business metrics.",
    "description_user": "Track your listings performance and engagement metrics.",
    "filters": {
      "last_30_days": "Last 30 Days"
    },
    "metrics": {
      "inquiries": "inquiries",
      "views_count_one": "{{count}} views",
      "views_count_other": "{{count}} views"
    },
    "stats": {
      "interested_tenants": "Interested Tenants",
      "total_properties": "Total Properties",
      "total_views": "Total Views"
    },
    "super_admin": {
      "active_organizations": "Active Organizations",
      "estimated_revenue": "Estimated Revenue",
      "total_platform_users": "Total Platform Users"
    },
    "title_super_admin": "Platform Overview",
    "title_user": "Performance Analytics"
  },
  "analytics_report_modal": {
    "actions": {
      "export_csv": "Export CSV"
    },
    "description": "Analysis of your top performing properties by views and engagement.",
    "empty": "No data available for this report.",
    "errors": {
      "load_failed": "Failed to load report data"
    },
    "loading": "Loading report data...",
    "success": {
      "exported": "Report downloaded successfully"
    },
    "table": {
      "inquiries": "Inquiries",
      "location": "Location",
      "price": "Price",
      "property": "Property",
      "status": "Status",
      "views": "Views"
    },
    "title": "Detailed Content Performance Report"
  },
  "api_usage": {
    "description": "View request counts, usage by user or organization, and daily breakdown. Superadmin only.",
    "summary": {
      "card_description": "Total API requests and breakdown by endpoint for the selected period.",
      "card_title": "Summary"
    },
    "tabs": {
      "by_org": "By Organization",
      "by_user": "By User",
      "daily": "Daily",
      "recent": "Recent",
      "summary": "Summary"
    },
    "title": "API Usage"
  },
  "assistant": {
    "badge_search": "Search",
    "confirm_delete_desc": "Are you sure you want to delete this search? The chat and saved results will be permanently removed.",
    "confirm_delete_title": "Delete search?",
    "delete_search": "Delete search",
    "exit_dashboard": "Go to Dashboard",
    "header_credits_hint": "Usage & billing",
    "header_home_aria": "Go to home",
    "header_profile_aria": "Account menu",
    "header_sign_in_aria": "Sign in",
    "hero_greeting": "What would you like to find today?",
    "hero_tagline": "Homes, plots, and workspaces—ask in plain language.",
    "hide_map": "Hide map",
    "language": "Language",
    "map_city_center_short": "Centered on {{city}}",
    "map_pin_count_one": "{{count}} on map",
    "map_pin_count_other": "{{count}} on map",
    "map_short": "Map",
    "no_searches_yet": "No searches yet. Start chatting to find properties.",
    "on_map": "on map",
    "placeholder": "Describe the property you want…",
    "quick_menu_aria": "Appearance and settings",
    "recent_searches": "Recent searches",
    "results_map": "Search results map",
    "resume": {
      "continue": "Continue last search",
      "description": "You have a recent property search. Continue where you left off, or start a new one.",
      "start_new": "Start a new search",
      "title": "Continue your last search?"
    },
    "search_delete_failed": "Failed to delete search",
    "search_deleted": "Search deleted",
    "searching_hint": "Scanning listings in your area…",
    "searching_status": "Finding matching properties",
    "sidebar_title": "My searches",
    "theme": "Theme",
    "theme_dark": "Dark",
    "theme_light": "Light",
    "voice_toggle": "Tap to start / stop voice"
  },
  "auth": {
    "accept_terms_required": "You must accept the terms",
    "after_verifying": "after verifying your email.",
    "agree_to_terms": "I agree to the",
    "already_have_account": "Already have an account?",
    "and": "and",
    "billing_country": "Country of residence",
    "billing_country_hint": "Your wallet will use {{currency}}. This is set at registration and cannot be changed later.",
    "checking_availability": "Checking availability...",
    "city": "City",
    "confirm_password": "Confirm password",
    "confirm_your_password": "Confirm your password",
    "continue_with_facebook": "Continue with Facebook",
    "continue_with_google": "Continue with Google",
    "continue_with_phone": "Continue with Phone",
    "create_account": "Create your account",
    "create_password": "Create a password",
    "creating_account": "Creating account...",
    "dont_have_account": "Don't have an account?",
    "email": "Email",
    "email_or_username": "Email or username",
    "enter_city": "e.g. Hyderabad, Ahmedabad",
    "enter_credentials": "Enter your credentials to access your account",
    "enter_email": "Enter your email",
    "enter_email_or_username": "Enter your email or username",
    "enter_first_name": "John",
    "enter_info": "Enter your information to create your account",
    "enter_last_name": "Doe",
    "enter_organization_name": "Your builder name",
    "enter_password": "Enter your password",
    "enter_phone": "9876543210",
    "enter_phone_national": "Enter your phone number",
    "enter_username": "johndoe",
    "fill_all_required": "Please fill in all required fields for the selected registration type",
    "first_name": "First name",
    "first_name_required": "First name is required",
    "forgot_password": "Forgot password?",
    "forgot_password_page": {
      "description": "Enter your email address and we'll send you a link to reset your password.",
      "email_label": "Email address",
      "email_placeholder": "you@example.com",
      "error_generic": "Something went wrong. Please try again.",
      "send_link": "Send reset link",
      "sending": "Sending...",
      "success_check": "Check your inbox and spam folder.",
      "success_title": "If the email exists, a password reset link has been sent.",
      "title": "Forgot your password?"
    },
    "google_signin_failed": "Google sign-in failed. Please try again.",
    "i_am_a": "I am a",
    "identifier_required": "Email or username is required",
    "identifier_too_long": "Must be 254 characters or fewer",
    "individual_desc": "Search, rent, buy, or list your property",
    "invalid_session": "Invalid Session",
    "last_name": "Last name",
    "last_name_required": "Last name is required",
    "list_properties": "List properties",
    "login_failed": "Login failed. Please try again.",
    "login_here": "login here",
    "looking_for_properties": "Looking for properties",
    "or_continue_with": "Or continue with",
    "org_desc": "I develop or sell real estate projects",
    "organization_name": "Builder Name",
    "organization_slug": "Builder Slug",
    "password": "Password",
    "password_complexity": "Password must contain uppercase, lowercase, and a number",
    "password_min_length": "Password must be at least 6 characters",
    "passwords_dont_match": "Passwords don't match",
    "phone": {
      "code_placeholder": "123456",
      "description": "We'll send a one-time code to your phone number.",
      "errors": {
        "code_expired": "Code expired. Please resend the verification code.",
        "invalid_code": "Invalid verification code. Please try again.",
        "invalid_phone": "Invalid phone number. Please use E.164 format (e.g. +1 650-555-3434).",
        "missing_confirmation": "Missing confirmation state. Please resend the code."
      },
      "format_hint": "Use E.164 format (starts with +).",
      "label": "Phone number",
      "localhost_note": "Note: with App Check enabled/enforced, localhost requires a debug token. Use test phone numbers locally or configure the App Check debug token.",
      "placeholder": "+1 650-555-3434",
      "send_code": "Send code",
      "sending": "Sending…",
      "title": "Continue with Phone",
      "verification_code": "Verification code",
      "verify_continue": "Verify & continue",
      "verifying": "Verifying…"
    },
    "phone_number": "Phone Number",
    "phone_session_expired": "Your phone verification session has expired. Please try again.",
    "phone_verified": "Phone number verified",
    "pm_desc": "I manage multiple properties for owners",
    "privacy_policy": "Privacy Policy",
    "register": "Register",
    "register_btn": "Create account",
    "registering_as_builder": "Registering as a Builder",
    "registering_as_individual": "Creating your personal account",
    "registering_as_pm": "Registering as a Property Manager",
    "registration_failed": "Registration failed. Please try again.",
    "registration_failed_title": "Registration Failed",
    "registration_success_desc": "Your account has been created successfully, {{name}}!",
    "registration_success_message": "Almost done! Please check your email and verify your address to activate your account. Your account will be created only after you click the verification link.",
    "remember_me": "Remember me",
    "role_org_desc": "I develop or sell real estate projects",
    "role_pm_desc": "I manage multiple properties for owners",
    "search_country_or_code": "Search country or code…",
    "select_billing_country": "Select your country",
    "sign_in": "Sign in",
    "sign_in_link": "Sign in",
    "sign_in_subtitle": "Sign in to your account to continue",
    "sign_up": "Sign up",
    "signing_in": "Signing in...",
    "start_free_trial": "Start your free trial today",
    "start_trial": "Start your free trial today",
    "success_login_message": "You can close this tab or",
    "tabs": {
      "organization": "Builder",
      "property_manager": "Property Manager"
    },
    "terms_service": "Terms of Service",
    "try_suggestions": "Try:",
    "username": "Username",
    "username_available": "Username is available!",
    "username_min_length": "Username must be at least 3 characters",
    "username_taken": "Username is taken. Try one of these:",
    "valid_email": "Please enter a valid email address",
    "welcome_back": "Welcome back",
    "welcome_title": "Welcome to LetMeIn! 🎉",
    "work_city": "City you work in"
  },
  "auto_test": {
    "card_1": {
      "button": "View All Properties",
      "desc": "Browse available properties in your area.",
      "title": "Real Estate Listings"
    },
    "card_2": {
      "button": "Start AI Search",
      "desc": "Find your dream home using natural language.",
      "title": "Smart AI Search"
    },
    "card_3": {
      "button": "Enable Notifications",
      "desc": "Get notified the moment a new deal matches your profile.",
      "title": "Instant Notifications"
    },
    "footer_message": "This page was built to test the 100% automated translation workflow.",
    "page_subtitle": "Watch how the system automatically detects, extracts, and translates this entire page.",
    "page_title": "AI Translation Magic"
  },
  "automation_test": {
    "action_button": "Get Started",
    "description": "This is an automated translation test page.",
    "title": "Automation Test"
  },
  "billing": {
    "add_credits": "Add credits",
    "amount": "Amount",
    "balance": "Balance",
    "billing_country": "Billing country",
    "billing_locale": "Billing & Wallet",
    "billing_locale_desc": "Your billing country and wallet currency for credits and usage.",
    "country_currency_mismatch_note": "Your wallet currency may differ from your billing country when credits were issued in another currency.",
    "date": "Date",
    "description": "Description",
    "est_cost": "Est. cost",
    "last_days": "Last {{days}} days",
    "ledger_description": "Recent credit movements",
    "near_cap_warning": "You are close to your usage cap.",
    "no_transactions": "No transactions yet.",
    "no_usage": "No usage data",
    "over_cap_warning": "You have reached your usage cap. Further charges may be blocked until the next period.",
    "showing_range": "Showing {{from}}–{{to}} of {{total}}",
    "topup_success": "Credits added successfully. Your balance has been updated.",
    "total_calls": "Total calls",
    "total_cost": "Total cost",
    "total_tokens": "Total tokens",
    "transaction_history": "Transaction history",
    "type": "Type",
    "upgrade_plan": "Upgrade plan",
    "usage_cap": "Usage cap",
    "usage_cap_description": "Current period spending limit from your plan.",
    "usage_description": "View your credits balance, API usage, and transaction history.",
    "usage_this_period": "Usage this period",
    "usage_title": "Usage & Billing",
    "used_this_period": "Used this period",
    "wallet_currency": "Wallet currency"
  },
  "brokerage": {
    "actions": {
      "accept": "Accept",
      "cancel_invite": "Cancel Invite",
      "decline": "Decline",
      "revoke_access": "Revoke Access",
      "view_building": "View Building"
    },
    "description": "Manage property assignments, professional connections, and operations across your portfolio.",
    "empty_states": {
      "invitations_desc": "Incoming and outgoing requests will appear here.",
      "no_active": "No active assignments yet.",
      "no_invitations": "No pending invitations at the moment."
    },
    "invite_manager": "Invite Manager",
    "labels": {
      "full_access": "Full Operational Access",
      "incoming": "Incoming",
      "invited_manager": "Invited: {{manager}}",
      "managed_by": "Managed by:",
      "manager_fallback": "Manager",
      "outgoing": "Outgoing",
      "owner": "Owner:",
      "owner_fallback": "Owner",
      "property_fallback": "Property",
      "requested_perms": "Requested Permissions:"
    },
    "messages": {
      "status_update_failed": "Failed to update invitation",
      "status_updated": "Invitation status updated to {{status}}"
    },
    "modals": {
      "choose_manager": "-- Choose a manager --",
      "choose_property": "-- Choose a property --",
      "default_permissions": "Default Permissions",
      "invite_desc": "Connect your property with a professional broker.",
      "invite_failed": "Failed to send invitation",
      "invite_success": "Invitation sent successfully!",
      "invite_title": "Invite a Property Manager",
      "no_managers": "No property managers found in the system yet.",
      "permissions_note": "Managers can view and manage day-to-day operations but cannot delete the property.",
      "select_manager": "Select Property Manager",
      "select_property": "Select Property",
      "send_invitation": "Send Invitation",
      "sending": "Sending..."
    },
    "permissions": {
      "edit_details": "Edit Details",
      "manage_tenants": "Manage Tenants",
      "send_alerts": "Send Alerts"
    },
    "status": {
      "active": "Active",
      "managed": "Managed",
      "pending": "Pending",
      "rejected": "Rejected",
      "revoked": "Revoked"
    },
    "tabs": {
      "active_portfolio": "Active Portfolio",
      "invitations": "Invitations",
      "maintenance": "Maintenance"
    },
    "title": "Brokerage & Authorization"
  },
  "buttons": {
    "submit": "Submit"
  },
  "chat": {
    "add_credits": "Add credits",
    "assistant_status": "Ready to find your next home",
    "assistant_title": "AI Property Assistant",
    "error_generic": "Sorry, I encountered an error. Please try again.",
    "error_voice": "Sorry, I had trouble processing your voice input.",
    "greeting": "Hi! I'm here to help you find your perfect property. Tell me what you're looking for - type, location, budget, amenities, or any specific requirements.",
    "guest_limit_reached": "You've reached today's free property search limit. Register or sign in for more searches.",
    "guest_limit_reached_mid": "or",
    "guest_limit_reached_prefix": "You've reached today's free property search limit.",
    "guest_limit_reached_suffix": "for more searches, or try again tomorrow.",
    "history_title": "Conversation History",
    "image_alert_size": "Image must be under 10 MB.",
    "image_alert_type": "Please select a JPEG, PNG, or WebP image.",
    "image_input_placeholder": "Add location context e.g. \"near Gachibowli\" (optional)...",
    "image_search_badge": "Image Search",
    "image_search_failed_generic": "Image search failed. Please try again.",
    "image_search_label": "🔍 Image search",
    "input_placeholder": "Type your message here...",
    "insufficient_balance": "Your credit balance has run out. Add credits to continue.",
    "insufficient_balance_prefix": "Your credit balance has run out.",
    "insufficient_balance_suffix": "to continue.",
    "location_dialog": {
      "description": "To find the best properties for you, we need to know which city you're interested in.",
      "footer": "Your location helps our AI find precise matches in your area.",
      "title": "Location Required"
    },
    "may_take_a_while": "It may take a while...",
    "my_location_unavailable": "I couldn't access your current location. Enable location permission in your browser and try again.",
    "new_chat": "New Chat",
    "new_search": "New Search",
    "posting_greeting": "Hi! I'm here to help you list your property. Start with pincode or full address if you can — or share type, area/locality, city, price, and photos.",
    "processing_details": "Processing property details…",
    "register": "Register",
    "search": "Search",
    "search_by_image": "Search by image",
    "search_by_image_title": "Search by image",
    "search_conversations": "Search conversations…",
    "search_image": "Search image",
    "setting_up": "Preparing next step…",
    "sign_in": "Sign in",
    "voice_label": "Voice",
    "wait_for_moment": "Wait for a moment..."
  },
  "checkout_page": {
    "actions": {
      "back_to_plans": "Back to Plans",
      "pay_amount": "Pay {{amount}}",
      "processing": "Processing..."
    },
    "error_state": {
      "title": "Checkout Error"
    },
    "errors": {
      "init_failed": "Failed to initialize payment",
      "missing_plan": "Missing plan information",
      "payment_failed": "Payment failed",
      "subscription_create_failed": "Payment succeeded but subscription creation failed. Please contact support."
    },
    "loading": {
      "preparing": "Preparing checkout..."
    },
    "order_summary": {
      "billing": "Billing:",
      "billing_fallback": "monthly",
      "plan": "Plan:",
      "plan_fallback": "Plan",
      "selected_plan": "Selected Plan",
      "title": "Order Summary",
      "total": "Total:"
    },
    "subtitle": "Enter your payment details to complete your subscription",
    "title": "Complete Your Payment"
  },
  "common": {
    "actions": "Actions",
    "activate": "Activate",
    "active": "Active",
    "add": "Add",
    "app_notifications": "In-App Alerts",
    "back": "Back",
    "cancel": "Cancel",
    "checking": "Checking…",
    "close": "Close Activity Window",
    "confirm": "Confirm",
    "continue": "Continue",
    "date": "Date",
    "days": "Days",
    "deactivate": "Deactivate",
    "delete": "Delete",
    "done": "Done",
    "edit": "Edit",
    "email": "Email Address",
    "email_notifications": "Email Alerts",
    "error_fetch_data": "Failed to load brokerage data",
    "error_occurred": "An error occurred",
    "filter": "Filter",
    "filter_all": "All",
    "first_name": "First Name",
    "generating": "Generating...",
    "go_back": "Go Back",
    "id": "ID",
    "inactive": "Inactive",
    "is_required": "is required",
    "language": "Preferred Language",
    "last_name": "Last Name",
    "live": "Live",
    "load": "Load",
    "loading": "Loading...",
    "loading_dashboard": "Loading dashboard...",
    "mark_unverified": "Click to Unverify",
    "mark_verified": "Click to Verify",
    "menu": "Menu",
    "next": "Next",
    "no": "No",
    "no_results_desc": "No properties found. Try a different search.",
    "no_results_found": "No Results Found",
    "not_available": "—",
    "off": "Off",
    "on": "On",
    "organization": "Organization",
    "pending": "Pending",
    "phone": "Phone Number",
    "previous": "Previous",
    "properties_found": "properties found",
    "refresh": "Refresh",
    "remove": "Remove",
    "required_fields": "Required fields",
    "results": "View Results",
    "retry": "Retry",
    "role": "Primary Role",
    "save": "Save",
    "save_changes": "Save Changes",
    "saving": "Saving...",
    "search": "Search Properties",
    "search_results": "Search Results",
    "searching_properties": "Searching properties...",
    "select": "Select",
    "select_all_that_apply": "Select all that apply",
    "send": "Send",
    "share": "Share",
    "skip": "Skip",
    "status": "Status",
    "statuses": {
      "completed": "Completed",
      "error": "Error",
      "failed": "Failed",
      "healthy": "Healthy",
      "not_checked": "Not checked",
      "pending": "Pending",
      "unconfigured": "Not configured"
    },
    "submit": "Submit",
    "system": "System",
    "translating": "Translating...",
    "try_again": "Try Again",
    "type": "Type",
    "update": "Update",
    "username": "Username",
    "verified": "Email Verification",
    "view": "View",
    "yes": "Yes"
  },
  "compare_page": {
    "actions": {
      "browse_properties": "Browse Properties",
      "retry_search": "Retry Search"
    },
    "empty": {
      "add_one_more": "Add at least one more property to compare",
      "no_base_hint": "Go to a property page and click \"Compare Projects\".",
      "no_base_selected": "No base property selected.",
      "no_recent_or_suggested": "No recent or suggested properties yet. Try searching above.",
      "no_search_results": "No properties found.",
      "use_search_panels": "Use the search panels above to find and add properties."
    },
    "errors": {
      "base_load_failed": "Could not load the base property for comparison.",
      "base_unavailable": "Unable to load base property.",
      "search_failed": "Search failed. Please try again.",
      "suggestions_load_failed": "Could not load suggested properties right now."
    },
    "labels": {
      "base_property": "Base Property",
      "last_viewed": "Last Viewed",
      "property_n": "Property {{index}}",
      "suggested_properties": "Suggested Properties"
    },
    "loading": {
      "page": "Loading properties for comparison...",
      "suggestions": "Loading suggestions..."
    },
    "search": {
      "placeholder": "Search by title, city, area..."
    },
    "side_by_side_title": "Side-by-Side Comparison",
    "table": {
      "amenities": "Amenities",
      "bathrooms": "Bathrooms",
      "bedrooms": "Bedrooms",
      "built_up_area": "Built-Up Area",
      "floor": "Floor",
      "furnishing": "Furnishing",
      "location": "Location",
      "price": "Price",
      "status": "Status",
      "type": "Type"
    },
    "title": "Compare Properties"
  },
  "contact_page": {
    "desc": "Have questions about our AI-powered real estate platform? We're here to help.",
    "form_card": {
      "email": "Email",
      "error_failed": "Failed to send message. Please try again later.",
      "error_fields": "Please fill in all required fields",
      "first_name": "First name",
      "last_name": "Last name",
      "message": "Message",
      "placeholder_email": "john@example.com",
      "placeholder_first_name": "John",
      "placeholder_last_name": "Doe",
      "placeholder_message": "Type your message here...",
      "placeholder_subject": "How can we help?",
      "subject": "Subject",
      "submit_btn": "Send Message",
      "submitting_btn": "Sending...",
      "success_msg": "Your message has been sent successfully!",
      "title": "Send us a Message"
    },
    "info_card": {
      "call_schedule": "Mon-Fri from 9am to 6pm",
      "call_title": "Call Us",
      "email_title": "Email Us",
      "title": "Contact Information",
      "visit_address": "Tech Hub, Hitech City<br />Hyderabad, Telangana 500081<br />India",
      "visit_title": "Visit Us"
    },
    "title": "Get in Touch"
  },
  "currency": {
    "cr": "Cr",
    "lakhs": "Lakhs"
  },
  "dashboard": {
    "aadhaar_reminder": {
      "cta": "Verify now",
      "description": "Complete Aadhaar verification to build trust on listings and tenant interactions.",
      "dismiss": "Dismiss reminder",
      "title": "Verify your identity with Aadhaar"
    },
    "admin_desc": "Overview of system analytics and management.",
    "admin_title": "Admin Dashboard",
    "find_home_desc": "Ready to find your next home?",
    "find_home_title": "AI Search",
    "merged_desc": "Search for homes, manage your listings, and track everything in one place.",
    "org_desc": "Manage your organization and member activities.",
    "org_title": "Organization Dashboard",
    "own_property_desc": "Post your property listing and switch to an owner account — our AI makes it quick and easy.",
    "own_property_title": "Do you own a property?",
    "owner_dashboard_title": "Owner Dashboard",
    "pm_desc": "Track your properties and tenant interactions.",
    "pm_title": "Property Manager Dashboard",
    "post_my_property": "Post My Property",
    "recent_searches_desc": "Properties from your last AI search",
    "recent_searches_title": "Recent Searches",
    "start_ai_search": "Start AI Search",
    "tenant_dashboard_title": "Tenant Dashboard",
    "tenant_desc": "Here's what's happening with your account today.",
    "welcome_back": "Welcome back, {{name}}"
  },
  "dashboard_page": {
    "title": "Dashboard",
    "welcome": "Welcome to your dashboard."
  },
  "deleteUser": {
    "adminWarningDesc": "You are about to delete an administrative account. This action requires extra confirmation and has significant system impact.",
    "adminWarningTitle": "High-Privilege Account",
    "cancel": "Cancel",
    "confirmMessage": "Are you sure you want to delete",
    "deactivate": "Deactivate",
    "deleteButton": "Delete User",
    "deleting": "Deleting...",
    "errorGeneric": "Failed to delete user. Please check your permissions.",
    "hardDelete": {
      "description": "- Permanently remove user and all data (cannot be undone)",
      "title": "Hard Delete"
    },
    "permanent": "Permanent",
    "softDelete": {
      "description": "- Deactivate user (can be reactivated later)",
      "title": "Soft Delete"
    },
    "title": "Delete User"
  },
  "demo": {
    "auto_test_all": "This key should automatically appear in English, Hindi, and Telugu!",
    "buttons": {
      "later": "Try Later",
      "start": "Get Started"
    },
    "descriptions": {
      "main": "This component is used to demonstrate how i18next-parser works."
    },
    "footer": {
      "info": {
        "v1": "Demo Version 1.0.0"
      }
    },
    "trans_demo": "You can also use <1>HTML tags</1> inside translations!",
    "welcome_title": "Welcome to the Demo"
  },
  "example": {
    "description": "This is an example description.",
    "title": "Example Title",
    "trans_component": "This is a translatable component."
  },
  "favourites_page": {
    "empty_desc": "Start exploring properties and save your favorites here!",
    "empty_title": "No favourites yet",
    "load_failed": "Failed to load favourites",
    "loading": "Loading your favourites...",
    "showing_one_one": "favourites_page.showing_one_one",
    "showing_one_other": "favourites_page.showing_one_other",
    "showing_other_one": "favourites_page.showing_other_one",
    "showing_other_other": "favourites_page.showing_other_other",
    "subtitle": "Properties you've liked and saved for later",
    "title": "My Favourites"
  },
  "features_page": {
    "badge": "Platform Features",
    "create_account_btn": "Create Free Account",
    "cta_quote": "\"The most advanced property search platform I've ever used. It actually understands what I need.\"",
    "cta_title": "Ready to find your <1/>next home with AI?",
    "features": {
      "conversational_ui": "Conversational UI",
      "conversational_ui_desc": "Interact with our platform just like you're talking to a professional real estate agent through our chat interface.",
      "instant_translation": "Instant Translation",
      "instant_translation_desc": "Communicate fluently with real-time translation in English, Hindi, and Telugu across the platform.",
      "intelligent_matching": "Intelligent Matching",
      "intelligent_matching_desc": "Our AI learns your preferences over time to suggest properties that truly fit your unique lifestyle.",
      "market_insights": "Market Insights",
      "market_insights_desc": "Get deep data on local market trends, pricing history, and neighborhood development powered by AI analysis.",
      "multilingual_support": "Multilingual Support",
      "multilingual_support_desc": "Navigate the entire platform in your preferred language. Full support for English, Hindi, and Telugu.",
      "owner_dashboard": "Owner Dashboard",
      "owner_dashboard_desc": "Powerful tools for property owners to manage listings, track leads, and handle tenant communication efficiently.",
      "smart_ai_search": "Smart AI Search",
      "smart_ai_search_desc": "Search properties using natural language queries. No more complex filters or technical jargon.",
      "verified_listings": "Verified Listings",
      "verified_listings_desc": "Every listing is rigorously verified by our AI and community checks to ensure 100% safety and legitimacy.",
      "virtual_tours": "Virtual Tours",
      "virtual_tours_desc": "Explore properties from the comfort of your home with AI-enhanced photography and spatial awareness.",
      "voice_search": "Voice Search",
      "voice_search_desc": "Search for properties using just your voice. Our AI understands natural speech in multiple languages for hands-free searching."
    },
    "hero_desc": "Experience the future of real estate with our comprehensive suite of AI tools designed to simplify your journey from searching to moving in.",
    "hero_title": "Intelligence in Every <1/>Property Search",
    "try_ai_btn": "Try AI Search Now",
    "view_pricing_btn": "View Pricing"
  },
  "gemini_listing": {
    "badge_draft": "Draft",
    "badge_live": "Live",
    "collapse_sidebar": "Collapse sidebar",
    "hero": "What are you listing today?",
    "hero_hint": "Pincode or address first when you can; otherwise area, city, price, photos, or PG/commercial details — the preview updates as you chat.",
    "list_new_property": "List new property",
    "location_pick_catalog_hint": "From your enabled locations — pick one, type a number, or search the map if none fit.",
    "location_pick_choose_city_hint": "Several cities match — choose your city first, then you will pick your neighborhood.",
    "location_pick_cities_heading": "Choose your city",
    "location_pick_decline": "None of these — search on map",
    "location_pick_decline_user": "None of these — search on map",
    "location_pick_kind_city": "City",
    "location_pick_kind_locality": "Area",
    "location_pick_localities_heading": "Localities / neighborhoods",
    "location_pick_localities_in_metro": "Areas in {{metro}}",
    "location_pick_map_hint": "Map matches — pick one or type a number.",
    "location_pick_matching_cities": "Matching cities: {{cities}}",
    "location_pick_next": "Load more",
    "location_pick_next_user": "Load more localities",
    "location_pick_page_num": "Page {{page}} of {{pages}}",
    "location_pick_page_range": "Showing {{start}}–{{end}} of {{total}} localities",
    "location_pick_prev": "Previous",
    "location_pick_prev_user": "Previous localities",
    "nav_menu": "Menu",
    "no_listings_yet": "No drafts or listings yet. Start chatting to create one.",
    "open_preview": "Preview",
    "placeholder": "Describe your property (type, location, price, size) or enter a pincode/address…",
    "publishing_splash_subtitle": "Finalizing details and setting up your live property page…",
    "publishing_splash_title": "Publishing your property listing...",
    "recent_listings": "Recent listings",
    "sidebar_title": "My listings",
    "untitled_published": "Listed property"
  },
  "genui_playground": {
    "area_details_confirmed": "Area: {{list}}",
    "documents_uploaded_message": "I've uploaded {{count}} document{{suffix}}",
    "error_connecting_backend": "❌ Error connecting to GenUI backend.",
    "images_uploaded_message": "I've uploaded {{count}} image{{suffix}}",
    "maintenance_confirmed": "Maintenance: {{amount}} ({{frequency}})",
    "maintenance_included": "Maintenance Included",
    "pg_available_from": "Available from: {{when}}",
    "pg_common_amenities_selected": "Common area amenities: {{list}}",
    "pg_common_amenities_skip": "Common area amenities: none",
    "pg_detail_beds_per_room_one": "{{count}} beds/room",
    "pg_detail_beds_per_room_other": "{{count}} beds/room",
    "pg_detail_deposit": "deposit {{amount}}",
    "pg_detail_rent": "{{amount}}/bed per month",
    "pg_detail_rooms_one": "{{label}}: {{count}} rooms",
    "pg_detail_rooms_other": "{{label}}: {{count}} rooms",
    "pg_food_no": "Food available: No",
    "pg_food_yes": "Food available: Yes",
    "pg_food_yes_meals": "Food available: Yes ({{meals}})",
    "pg_gate_closing_none": "Gate closing: not required",
    "pg_gate_closing_set": "Tenants must return before {{when}}",
    "pg_present_in_selected": "PG present in: {{choice}}",
    "pg_room_facilities_selected": "Room facilities: {{list}}",
    "pg_room_facilities_skip": "Room facilities: none",
    "pg_rules_selected": "PG rules: {{list}}",
    "pg_rules_skip": "PG rules: none",
    "pg_services_confirmed": "Available services — {{list}}",
    "pg_sharing_types_selected": "Sharing options: {{list}}",
    "pg_tenant_preference": "Tenant preference: {{choice}}",
    "pg_usp_added": "PG USPs: {{list}}",
    "pg_usp_skip": "PG USPs: skipped",
    "preferred_tenants_selected": "Preferred tenants: {{list}}",
    "preferred_tenants_skip": "Preferred tenants: none",
    "title": "GenUI Playground"
  },
  "genui_widgets": {
    "age_of_construction": {
      "options": {
        "10_to_15_years": "10 to 15 years",
        "15_to_20_years": "15 to 20 years",
        "5_to_10_years": "5 to 10 years",
        "above_20_years": "Above 20 years",
        "less_than_5_years": "Less than 5 years",
        "new_construction": "New Construction",
        "not_available": "",
        "single_phase": "",
        "three_phase": ""
      },
      "placeholder": "Select",
      "title": "Age of Construction"
    },
    "amenities": {
      "add_your_own": "Add your own",
      "confirm": "Confirm Selection",
      "custom_placeholder": "e.g. Rooftop terrace...",
      "furnishing_section": "Furnishing",
      "items": {
        "balcony": "Balcony",
        "children_play_area": "Children Play Area",
        "chimney": "Chimney",
        "clubhouse": "Clubhouse",
        "curtains": "Curtains",
        "dining_table": "Dining Table",
        "exhaust_fan": "Exhaust Fan",
        "fans": "Fans",
        "fridge": "Fridge",
        "garden": "Garden",
        "gas_pipeline": "Gas Pipeline",
        "geyser": "Geyser",
        "gymnasium": "Gymnasium",
        "internet_wifi": "Internet/Wi-Fi",
        "lift": "Lift",
        "light": "Light",
        "maintenance_staff": "Maintenance Staff",
        "microwave": "Microwave",
        "modular_kitchen": "Modular Kitchen",
        "park": "Park",
        "parking": "Parking",
        "power_backup": "Power Backup",
        "rain_water_harvesting": "Rain Water Harvesting",
        "reserved_parking": "Reserved Parking",
        "security_24x7": "24x7 Security",
        "sofa": "Sofa",
        "stove": "Stove",
        "swimming_pool": "Swimming Pool",
        "visitor_parking": "Visitor Parking",
        "wardrobe": "Wardrobe",
        "washing_machine": "Washing Machine",
        "water_purifier": "Water Purifier",
        "water_storage": "Water Storage"
      },
      "selected_count_one": "{{count}} selected",
      "selected_count_other": "{{count}} selected",
      "title": "Select Amenities"
    },
    "area_details": {
      "confirm": "Confirm Area",
      "error_ordering": "Please ensure Carpet Area ≤ Built-up Area ≤ Super Built-up Area, and Super Built-up Area must be greater than Built-up Area.",
      "error_positive": "Area values must be greater than 0.",
      "error_units": "Please ensure all area fields use the same unit of measurement.",
      "help": "Area help",
      "help_text": "Enter at least one area. You can add carpet, built-up, and super built-up if you know them.",
      "mandatory": "Atleast one area type is mandatory",
      "plot": "Plot Area",
      "title": "Add Area Details",
      "total": "Total Area"
    },
    "area_input": {
      "confirm": "Confirm Area",
      "placeholder": "e.g. 1500",
      "title": "Property Size",
      "units": {
        "acres": "Acres",
        "bigha": "Bigha",
        "cents": "Cents",
        "guntas": "Guntas",
        "marla": "Marla",
        "sqft": "Sq. Ft.",
        "sqyd": "Sq. Yd."
      }
    },
    "area_type": {
      "built_up": "Built-up Area",
      "carpet": "Carpet Area",
      "plot": "Plot Area",
      "super_built_up": "Super Built-up Area",
      "title": "Area Type"
    },
    "available_from": {
      "immediately": "Immediately",
      "month_year": "Or enter month / year",
      "placeholder": "e.g. June 2026",
      "title": "Available from"
    },
    "booking_token_amount": {
      "confirm": "Confirm",
      "placeholder": "e.g. 100000",
      "title": "Booking / Token Amount"
    },
    "commercial_furnishing": {
      "title": "Furnishing status"
    },
    "commercial_subtype": {
      "commercial_land": "Commercial Land",
      "commercial_office_space": "Commercial Office Space",
      "commercial_shop": "Commercial Shop",
      "commercial_showroom": "Commercial Showroom",
      "industrial_building": "Industrial Building",
      "industrial_land": "Industrial Land",
      "industrial_shed": "Industrial Shed",
      "office_it_park_sez": "Office in IT Park / SEZ",
      "title": "Commercial property type",
      "warehouse_godown": "Warehouse / Godown"
    },
    "commercial_zone": {
      "agricultural_zone": "Agricultural Zone",
      "commercial": "Commercial",
      "government_use": "Government Use",
      "industrial": "Industrial",
      "natural_conservation_zone": "Natural Conservation Zone",
      "open_spaces": "Open Spaces",
      "public_semi_public": "Public and Semi Public Use",
      "public_utilities": "Public Utilities",
      "residential": "Residential",
      "special_economic_zone": "Special Economic Zone",
      "title": "Land zoning",
      "transport_communication": "Transport and Communication"
    },
    "connectivity": {
      "add_your_own": "Add your own",
      "continue_one": "Continue ({{count}} selected)",
      "continue_other": "Continue ({{count}} selected)",
      "items": {
        "airport": "Airport",
        "bus_stop": "Bus Stop",
        "highway_orr": "Highway/ORR",
        "main_road": "Main Road",
        "metro_station": "Metro Station",
        "nearby_landmark": "Nearby Landmark"
      },
      "placeholder": "e.g. Hitech City Metro - 5 min",
      "selected_count_one": "{{count}} selected",
      "selected_count_other": "{{count}} selected",
      "skip": "Skip",
      "title": "Connectivity"
    },
    "counter": {
      "confirm_one": "Confirm {{count}} {{label}}",
      "confirm_other": "Confirm {{count}} {{label}}",
      "labels": {
        "balconies_one": "Balcony",
        "balconies_other": "Balconies",
        "bathrooms_one": "Bathroom",
        "bathrooms_other": "Bathrooms",
        "bedrooms_one": "Bedroom",
        "bedrooms_other": "Bedrooms",
        "lifts_one": "Lift/Elevator",
        "lifts_other": "Lifts/Elevators",
        "open_sides_one": "Open Side",
        "open_sides_other": "Open Sides",
        "total_floors_one": "total floor",
        "total_floors_other": "total floors"
      },
      "skip": "Skip"
    },
    "extra_pantry": {
      "dry_pantry": "Dry pantry",
      "not_available": "Not available",
      "wet_pantry": "Wet pantry"
    },
    "facing": {
      "east": "East",
      "north": "North",
      "north_east": "North-East",
      "north_west": "North-West",
      "south": "South",
      "south_east": "South-East",
      "south_west": "South-West",
      "title": "Property Facing",
      "west": "West"
    },
    "floor_details": {
      "ground_floor": "Ground Floor",
      "title": "Floor & Building Details"
    },
    "furnishing": {
      "fully_furnished": "Fully Furnished",
      "fully_sub": "Move-in ready with furniture and appliances",
      "semi_furnished": "Semi Furnished",
      "semi_sub": "Basic fittings; bring your own furniture",
      "title": "Furnishing Status",
      "unfurnished": "Unfurnished",
      "unfurnished_sub": "Empty unit; no furniture included"
    },
    "ideal_for_businesses": {
      "title": "Ideal for businesses"
    },
    "locality_tier": {
      "developed": "Developed localities",
      "developed_sub": "Established residential & commercial hubs with mature amenities",
      "label": "Locality Tier",
      "premium": "Premium localities",
      "premium_sub": "High-end, prime luxury neighborhoods with top-tier lifestyle",
      "subtitle": "Select the tier that best describes this area",
      "tier_1": "Tier 1 Prime / Luxury",
      "tier_2": "Tier 2 Developed / Mature",
      "tier_3": "Tier 3 Emerging / Growth",
      "title": "Locality Classification",
      "upcoming": "Upcoming localities",
      "upcoming_sub": "High-growth potential, developing infrastructure & future appreciation"
    },
    "location": {
      "allow_or_pick": "Allow location access or pick your country. Locality and pincode options stay within that country.",
      "area_label": "Area / Neighborhood",
      "label": "Location / Neighborhood",
      "placeholder": "e.g. Gachibowli",
      "press_enter": "Press Enter to confirm location",
      "press_enter_locality": "Press Enter or click search to confirm locality",
      "searching_in": "Searching in",
      "set_country_first": "Set your country first",
      "use_current": "Use my current location"
    },
    "maintenance_charges": {
      "amount_label": "Maintenance Charges",
      "amount_placeholder": "Maintenance Charges",
      "confirm": "Confirm",
      "frequency": {
        "monthly": "Monthly",
        "one_time": "One-Time",
        "per_sq_unit_monthly": "Per sq. Unit Monthly",
        "quarterly": "Quarterly",
        "yearly": "Yearly"
      },
      "included_hint": "Rent already covers maintenance — no separate charge.",
      "included_hint_sale": "No separate maintenance charge — included or not applicable.",
      "included_label": "Maintenance Included",
      "per_label": "per",
      "skip": "Skip",
      "title": "Maintenance Charges"
    },
    "maintenance_frequency": {
      "title": "Maintenance frequency"
    },
    "media": {
      "add": "Add",
      "add_anyway": "Actually, add photos or video",
      "add_photos": "Add photos or video tour",
      "click_or_drag": "Click or drag files here",
      "documents_hint": "(Brochure, Floor Plan, Legal docs)",
      "documents_title": "Property Documents",
      "documents_types": "PDF, DOC, DOCX, XLS, XLSX, JPG, PNG · max {{mb}} MB each",
      "done": "Done",
      "file_too_large": "File too large (max {{mb}} MB)",
      "limit_partial": "Only {{remaining}} more item(s) could be added to stay within the {{max}} media limit.",
      "limit_reached": "Maximum media limit of {{max}} items reached (photos + video tour combined).",
      "no_media": "No media",
      "no_media_ok": "No media — that's okay!",
      "photos_formats": "Photos (JPEG, PNG) · Video (Max {{mb}}MB)",
      "preview_alt": "Preview",
      "remove": "Remove",
      "skip": "Skip",
      "skip_media": "Skip media",
      "summary_none": "No media yet (max {{max}})",
      "summary_photos_one": "{{photos}} photo ({{count}}/{{max}})",
      "summary_photos_other": "",
      "summary_photos_one_one": "",
      "summary_photos_one_other": "",
      "summary_photos_video_one": "{{photos}} photo, 1 video ({{count}}/{{max}})",
      "summary_photos_video_other": "",
      "summary_photos_video_one_one": "",
      "summary_photos_video_one_other": "",
      "summary_video_one": "",
      "summary_video_other": "",
      "unsupported_type": "Unsupported file type",
      "upload": "Upload",
      "upload_n_one": "",
      "upload_n_other": "",
      "upload_one_one": "",
      "upload_one_other": "",
      "video": "Video",
      "video_too_large": "Video \"{{name}}\" exceeds the {{mb}} MB limit.",
      "youtube": "YouTube",
      "youtube_add": "Add",
      "youtube_hint": "Adds a video tour without uploading a file",
      "youtube_invalid": "Enter a valid YouTube (or Vimeo) video link",
      "youtube_label": "Or paste a YouTube link",
      "youtube_placeholder": "https://www.youtube.com/watch?v=...",
      "youtube_preview": "YouTube preview",
      "youtube_required": "Paste a YouTube link first"
    },
    "mode_selector": {
      "rent": "Rent / Lease",
      "rent_hint": "I want to rent out",
      "sell": "Sell",
      "sell_hint": "I want to sell property"
    },
    "nearby_businesses": {
      "items": {
        "bank": "Bank",
        "cafe": "Cafe",
        "clinic": "Clinic",
        "hospital": "Hospital",
        "mall": "Mall",
        "pharmacy": "Pharmacy",
        "restaurant": "Restaurant",
        "retail_shops": "Retail Shops",
        "school": "School"
      },
      "title": "Nearby businesses"
    },
    "nearby_places": {
      "add_your_own": "Add your own",
      "continue_one": "Continue ({{count}} selected)",
      "continue_other": "Continue ({{count}} selected)",
      "items": {
        "gym": "Gym",
        "hospital": "Hospital",
        "park": "Park",
        "restaurant": "Restaurant",
        "school": "School",
        "shopping_mall": "Shopping Mall"
      },
      "placeholder": "e.g. Apollo Hospital - 2km",
      "selected_count_one": "{{count}} selected",
      "selected_count_other": "{{count}} selected",
      "skip": "Skip",
      "title": "Nearby Places"
    },
    "number_input": {
      "booking_token_amount": "Booking / Token Amount",
      "ceiling_height": "Ceiling height (ft)",
      "confirm": "Confirm",
      "entrance_width": "Entrance Width (ft)",
      "example_prefix": "e.g.",
      "floor_number": "Floor number",
      "floors_allowed_for_construction": "Floors Allowed",
      "open_sides": "Open Sides",
      "parking_spots": "Parking spots",
      "plot_breadth": "Plot breadth (ft)",
      "plot_length": "Plot length (ft)",
      "road_width": "Road Width",
      "road_width_facing_plot": "Road Facing Plot",
      "total_floors": "Total floors in building",
      "washroom_count": "Washroom Count"
    },
    "ownership": {
      "freehold": "Freehold",
      "freehold_sub": "Complete ownership of both land and structure with no end period",
      "label": "Ownership",
      "leasehold": "Leasehold",
      "leasehold_sub": "Ownership for a fixed period granted by government or landlord",
      "poa": "Power Of Attorney",
      "poa_sub": "Sale right executed through legal Power of Attorney authority",
      "society": "Co-operative Society",
      "society_sub": "Shares & transfer rights issued via registered housing co-operative",
      "subtitle": "Select property legal title / ownership status",
      "title": "Ownership Type"
    },
    "parking": {
      "confirm": "Confirm",
      "options": {
        "bike": "Bike Only",
        "bike_sub": "Two-wheeler parking only",
        "both": "Both (Car & Bike)",
        "both_sub": "Car & Two-wheeler slots",
        "car": "Car Only",
        "car_sub": "Dedicated 4-wheeler slots",
        "none": "No Parking",
        "none_sub": "No dedicated vehicle parking"
      },
      "skip": "Skip",
      "slots_label": "Car Parking Slots",
      "subtitle": "Select vehicle parking available",
      "title": "Parking Facility"
    },
    "pg_available_from": {
      "confirm": "Confirm",
      "immediately": "Immediately",
      "or_custom": "Or enter month / year",
      "placeholder": "e.g. June 2026",
      "section_label": "Available from"
    },
    "pg_available_services": {
      "confirm": "Confirm",
      "laundry": "Laundry",
      "room_cleaning": "Room Cleaning",
      "subtitle": "Which services does your PG provide for tenants?",
      "title": "Available Services",
      "warden": "Warden Facility"
    },
    "pg_common_amenities": {
      "confirm": "Confirm",
      "fridge": "Fridge",
      "gym": "Gym",
      "kitchen": "Kitchen",
      "lift": "Lift",
      "microwave": "Microwave",
      "power_backup": "Power Backup",
      "ro_water": "RO Water",
      "skip": "Skip",
      "subtitle": "Select all amenities available in common areas of your PG",
      "title": "Common area amenities",
      "tv": "TV",
      "washing_machine": "Washing Machine",
      "wifi": "WiFi"
    },
    "pg_food": {
      "confirm": "Confirm",
      "meals": {
        "breakfast": "Breakfast",
        "dinner": "Dinner",
        "lunch": "Lunch"
      },
      "meals_label": "Which meals? (optional)",
      "subtitle": "Does your PG provide food / meals for tenants?",
      "title": "Food available"
    },
    "pg_gate_closing": {
      "confirm": "Confirm",
      "field_label": "Gate closing time",
      "none": "No Gate Closing",
      "placeholder": "Select time",
      "title": "Tenants must be back in PG before"
    },
    "pg_occupancy": {
      "available_floors": "Available Floors (optional)",
      "beds_per_room": "Number of beds per room",
      "confirm_details": "Confirm",
      "continue": "Continue",
      "deposit_per_bed": "Security Deposit Per Bed (₹)",
      "double": "Double",
      "double_title": "Double Sharing (2 Beds)",
      "four": "Four",
      "four_title": "Four Sharing (4 Beds)",
      "other": "Other",
      "other_title": "Custom / Dormitory Layout",
      "rent_details_for": "Rent Details for {{type}} Room",
      "rent_per_bed": "Monthly Rent Per Bed (₹)",
      "rooms_count": "No. of {{type}} rooms in PG",
      "selected_count": "{{count}} selected",
      "selected_count_one": "{{count}} selected",
      "selected_count_other": "{{count}} selected",
      "sell_details_for": "Rooms for {{type}} sharing",
      "single": "Single",
      "single_title": "Single Occupancy (1 Bed)",
      "step_hint": "{{remaining}} option(s) remaining",
      "subtitle": "Select all sharing options you offer",
      "title": "Occupancy Details",
      "triple": "Triple",
      "triple_title": "Triple Sharing (3 Beds)"
    },
    "pg_present_in": {
      "independent_building": "An independent building",
      "independent_flats": "An independent flat(s)",
      "society": "Present in a society",
      "title": "PG is present in"
    },
    "pg_room_facilities": {
      "ac": "AC",
      "air_cooler": "Air cooler",
      "balcony": "Attached Balcony",
      "confirm": "Confirm",
      "copy_notice": "Apply same facilities as {{type}}",
      "cot": "Cot",
      "cupboard": "Cupboard",
      "fan": "Fan",
      "geyser": "Geyser",
      "locked_notice": "Amenities selected and locked from previous room",
      "mattress": "Mattress",
      "same_as_previous": "Same as previous",
      "side_table": "Side table",
      "skip": "Skip",
      "subtitle": "Select all facilities available in each room",
      "subtitle_for_type": "Select facilities available in {{type}} sharing rooms",
      "title": "Room Facilities",
      "title_for_type": "Room facilities — {{type}}",
      "tv": "TV",
      "washrooms": "Washrooms"
    },
    "pg_rules": {
      "confirm": "Confirm",
      "no_drinking": "No Drinking",
      "no_guardian": "No Guardian",
      "no_opposite_gender": "No Opposite Gender",
      "no_smoking": "No Smoking",
      "skip": "Skip",
      "subtitle": "Select all rules that apply to your PG",
      "title": "PG rules",
      "veg_only": "Veg Only"
    },
    "pg_tenant_preference": {
      "both": "Both",
      "professionals": "Professionals",
      "student": "Student",
      "subtitle": "Who do you prefer as tenants?",
      "title": "Tenant preferences"
    },
    "pg_usp": {
      "added": "Added USPs",
      "confirm": "Confirm",
      "examples_title": "Example USPs",
      "heading": "Tell us more about your PG",
      "placeholder": "e.g. Near metro station",
      "select_category": "Select category",
      "skip": "Skip",
      "subtitle": "Write a USP about your PG",
      "write_usp": "Write PG USP"
    },
    "possession_status": {
      "ready_to_move": "Ready to Move",
      "title": "Possession status",
      "under_construction": "Under Construction"
    },
    "power_supply": {
      "options": {
        "not_available": "Not available",
        "single_phase": "Single Phase",
        "three_phase": "Three Phase"
      },
      "title": "Power supply"
    },
    "preferred_tenants": {
      "anyone": "Anyone",
      "bachelor_female": "Bachelor Female",
      "bachelor_male": "Bachelor Male",
      "company": "Company",
      "confirm": "Confirm",
      "family": "Family",
      "subtitle": "Who are you looking to rent to? Select all that apply.",
      "title": "Preferred Tenants"
    },
    "price_input": {
      "confirm": "Confirm Price",
      "placeholder": "Enter amount",
      "price_negotiable": "Price is negotiable",
      "quick_picks": "Quick picks",
      "rent_suffix": "/ month",
      "title": "Set Your Price"
    },
    "property_address": {
      "confirm": "Confirm Address",
      "confirmed_message": "Property address confirmed",
      "directions_hint": "Don't want calls asking location? Add directions to reach using landmarks",
      "directions_placeholder": "Eg. Take the road opposite to Amrita College, take right after 300m…",
      "directions_title": "Add Directions Tip for your tenants",
      "pinned_verified": "Pin Verified",
      "preview": "Address Preview",
      "show_map_pin_desc_off": "Property still appears in search results, but the map pin will be hidden.",
      "show_map_pin_desc_on": "Your exact red pin will appear on the search map for buyers/tenants.",
      "show_map_pin_label": "Make address visible on search map",
      "subtitle": "Confirm or refine your exact postal street address.",
      "title": "Property Address Details"
    },
    "property_map_pin": {
      "address_unavailable": "Could not resolve a street address for this pin. Enable Places API and Geocoding API on your Google Maps key, then try again.",
      "approx_location": "Showing approximate network location. Enable browser GPS for exact pin.",
      "area_not_found": "Could not find that area. Try a neighborhood name, landmark, or fuller address.",
      "area_search_failed": "Area search failed. Check your connection and try again.",
      "area_search_label": "Search area on map",
      "area_search_placeholder": "Search locality, landmark or address",
      "confirm": "Confirm location",
      "confirmed_message": "Property location confirmed",
      "confirming": "Saving…",
      "edit_subtitle": "Search a place, pan the map, or drag the pin. The pin stays synced with the map center.",
      "edit_title": "Edit property location",
      "exit_fullscreen": "Exit Fullscreen (Esc)",
      "fullscreen": "Fullscreen",
      "latitude": "Latitude",
      "live_location_found": "Showing your live location",
      "locate_me": "My live location",
      "longitude": "Longitude",
      "osm_address_unavailable": "Could not resolve a street address for this pin. Try moving the pin slightly or check your network connection.",
      "recenter_pin": "Recenter on property pin",
      "save_location": "Save location",
      "select_location": "Drag or tap on the map to place your property pin",
      "subtitle": "Search a place, then pan the map or drag the pin to mark the exact spot of your property.",
      "title": "Pin your property location"
    },
    "rera": {
      "approved": "RERA Approved",
      "chat_confirmed_no": "Not RERA Registered",
      "chat_confirmed_with_id": "RERA Registered: Yes (ID: {{id}})",
      "chat_confirmed_yes": "RERA Registered: Yes",
      "chat_skipped": "Skip RERA",
      "confirm_button": "Confirm & Continue",
      "id_label": "RERA Registration ID / Number",
      "id_placeholder": "e.g. P02400001234",
      "label": "RERA Status",
      "not_registered": "Not RERA Registered",
      "registered": "RERA Registered",
      "skip": "Skip",
      "subtitle": "Is this property RERA approved / registered?",
      "title": "RERA Registration",
      "unregistered_sub": "Exempt or pending registration",
      "verified_sub": "Increases buyer trust & compliance"
    },
    "sale_type": {
      "label": "Sale Type",
      "new": "New",
      "new_sub": "Brand new property directly from builder/developer",
      "resale": "Resale",
      "resale_sub": "Pre-owned property being resold by the current owner",
      "subtitle": "Specify whether this is a new booking or resale",
      "title": "Sale Type"
    },
    "security_deposit": {
      "confirm": "Confirm",
      "placeholder": "e.g. 10000 or 0",
      "title": "Security Deposit"
    },
    "submit_success": {
      "list_another": "List Another Property",
      "subtitle": "Your property has been posted to the LetMeIn Marketplace",
      "title": "Property Listed Successfully!",
      "view_properties": "View My Properties"
    },
    "tag_multi_select": {
      "add_custom": "Add your own…",
      "continue": "Continue"
    },
    "type_selector": {
      "title": "Property Type"
    },
    "washroom_count": {
      "title": "Washroom count"
    },
    "yes_no": {
      "questions": {
        "does_it_have_a_personal_washroom": "Does it have a personal washroom?",
        "is_it_a_corner_plot": "Is it a corner plot?",
        "is_it_a_corner_shop": "Is it a corner shop?",
        "is_it_on_the_main_road": "Is it on the main road?",
        "is_there_a_boundary_wall": "Is there a boundary wall?",
        "is_washroom_available": "Is washroom available?",
        "loading_unloading_access": "Is loading/unloading access available?",
        "truck_accessibility": "Is truck access available?"
      }
    }
  },
  "help": {
    "community": {
      "description": "Join our community forum to discuss features and get help from other users.",
      "title": "Community",
      "visit": "Visit Community →"
    },
    "contact": {
      "direct_support": "Direct Support",
      "email_support": "Email Support",
      "respond_time": "We typically respond within 24 hours.",
      "tech_issues": "Technical Issues"
    },
    "faq": {
      "q1": {
        "a": "Go to the 'List My Property' section in the sidebar. You can use our AI-powered listing assistant to quickly generate a professional description and set details for your property.",
        "q": "How do I list my property?"
      },
      "q2": {
        "a": "The Brokerage Hub allows property owners to invite and manage property managers. You can assign specific properties to managers and track their performance directly from your dashboard.",
        "q": "What is the Brokerage Hub?"
      },
      "q3": {
        "a": "Navigate to the 'Subscription' page from the sidebar. There you can view your current plan, upgrade, or manage your billing details and transaction history.",
        "q": "How do I change my subscription plan?"
      },
      "q4": {
        "a": "Yes, we take security seriously. All your data is encrypted, and we use industry-standard authentication (Firebase) and payment processing (Stripe/Razorpay) to ensure your information is safe.",
        "q": "Is my data secure?"
      },
      "q5": {
        "a": "Once a tenant inquires about your property, you'll receive a notification. You can then go to the 'Messages' section to chat directly with them in real-time.",
        "q": "How can I contact a tenant?"
      }
    },
    "form": {
      "description": "Fill out the form below and our team will get back to you.",
      "email": "Email",
      "error": "Failed to send message. Please try again.",
      "error_long": "Failed to send support request. Please try again later.",
      "message": "Message",
      "name": "Name",
      "placeholder_email": "john@example.com",
      "placeholder_message": "Tell us more about what's on your mind...",
      "placeholder_name": "John Doe",
      "placeholder_subject": "Question about my subscription",
      "sending": "Sending...",
      "subject": "Subject",
      "submit": "Send Message",
      "success": "Message sent successfully!",
      "success_long": "Support request sent successfully! We'll get back to you soon.",
      "title": "Send us a message"
    },
    "requests": {
      "loading": "Loading messages...",
      "need_respond": "Needs response",
      "none_desc_admin": "No support requests have been received yet.",
      "none_desc_user": "You haven't sent any support requests yet.",
      "none_found": "No messages found",
      "refresh": "Refresh",
      "reply": {
        "cancel": "Cancel",
        "error": "Failed to send reply. Please check if SMTP is configured correctly.",
        "label": "Reply",
        "placeholder": "Type your reply...",
        "placeholder_long": "Type your reply here...",
        "send": "Send Reply",
        "success": "Reply sent successfully! The request status has been updated to resolved."
      },
      "reply_btn": "Reply",
      "request_resolved": "Resolved",
      "send_msg": "Send a message",
      "status": {
        "pending": "Pending",
        "resolved": "Resolved"
      },
      "title_admin": "All Support Requests",
      "title_user": "Your Support Requests"
    },
    "subtitle": "Find answers or get in touch with our team.",
    "tabs": {
      "contact": "Contact Us",
      "faq": "FAQ",
      "inbox": "Inbox",
      "requests": "My Requests"
    }
  },
  "image_search_page": {
    "actions": {
      "find_similar": "Find Similar Properties",
      "searching": "Searching for similar properties…"
    },
    "dropzone": {
      "click_browse": "click to browse",
      "drag_drop": "Drag & drop or",
      "drop_here": "Drop image here",
      "formats": "JPEG, PNG, WebP · Max 10 MB",
      "upload_photo": "Upload a property photo"
    },
    "errors": {
      "generic": "Something went wrong. Please try again.",
      "invalid_type": "Please use a JPEG, PNG, or WebP image.",
      "max_size": "Image must be under 10 MB.",
      "no_matches": "No matching properties found. Try a different image.",
      "paid_only": "🔒 Image search is available for paid users only."
    },
    "footer_note": "Results are ranked by visual similarity, then refined by location if provided.",
    "how_it_works": {
      "example": "\"near Gachibowli, Hyderabad\"",
      "prefix": "Upload a photo of a property you like. Our AI will find visually similar listings. Optionally add a location hint like",
      "suffix": "to narrow results by area."
    },
    "location_context": {
      "hint": "Adding a location gives you the most relevant results.",
      "label": "Location context",
      "optional": "optional",
      "placeholder": "e.g. \"near Gachibowli, Hyderabad\" or \"3 BHK apartment\""
    },
    "preview": {
      "change": "Change",
      "selected_alt": "Selected property"
    }
  },
  "impersonation": {
    "action": "Impersonate user",
    "banner_actor": "Signed in as super admin {{email}}.",
    "banner_body": "You are viewing the app as {{name}} ({{email}}).",
    "banner_title": "Impersonation active",
    "exit": "Exit impersonation",
    "failed": "Could not start impersonation.",
    "started": "Now viewing the app as this user.",
    "stop_failed": "Could not exit impersonation."
  },
  "landing": {
    "chat_placeholder": "Start chatting with our AI assistant...",
    "guide_desc": "We make it easy to find your perfect fit with personalized AI recommendations",
    "guide_title": "Let AI Guide You Home",
    "hero_desc": "Whether you're searching for a villa,lands,apartments,hostels, or any other property, our AI assistant is here to help you at every step. Get personalized recommendations instantly.",
    "hero_title_1": "Find Your Property.",
    "hero_title_2": "Live Your Dream.",
    "showcase_desc": "Experience the epitome of modern living",
    "showcase_title": "Luxury Apartment Showcase"
  },
  "landing_page": {
    "ai_search_btn": "AI Search",
    "analyzing": "Analyzing...",
    "feature_ai": "AI Powered",
    "feature_instant": "Instant Results",
    "feature_setup": "Instant Setup",
    "feature_verified": "Verified Listings",
    "footer": {
      "about_p1": "As the leading AI-powered real estate platform connecting property buyers and sellers, LetMeIn AI boasts over <0>50,000 monthly active users</0> and thousands of verified property listings. With our cutting-edge technology, we have evolved into a comprehensive property ecosystem, offering smart search, instant valuations, and expert investment advice.",
      "about_p2": "LetMeIn AI also offers extensive data-driven insights and market trends through our proprietary analytics dashboard, providing home buyers with accurate price forecasts, locality reviews, and investment opportunities tailored to their preferences.",
      "about_title": "About LetMeIn AI",
      "app_coming_soon_app_store": "The LetMeIn AI iOS app is not available yet. We'll notify you when it's live on the App Store.",
      "app_coming_soon_google_play": "The LetMeIn AI Android app is not available yet. We'll notify you when it's live on Google Play.",
      "app_coming_soon_title": "Mobile app coming soon",
      "app_store_aria": "Download on the App Store",
      "browse_properties": "Browse Properties",
      "google_play_aria": "Get it on Google Play",
      "privacy": "Privacy Policy",
      "rights_reserved": "© 2026 LetMeIn AI. All rights reserved.",
      "terms": "Terms of Service"
    },
    "get_details": "View Details",
    "header": {
      "listing_intent_nav_aria": "Buy, rent, or sell",
      "nav_buy": "Buy",
      "nav_rent": "Rent",
      "nav_sell": "Sell"
    },
    "header_profile_aria": "Account menu",
    "hero_subtitle": "AI-powered property search that understands exactly what you're looking for.",
    "hero_title_1": "Find Your",
    "hero_title_2": "Space",
    "hero_title_accent": "Perfect",
    "intent_nav": {
      "buy_commercial": "Commercial for sale",
      "buy_flats": "Flats & apartments",
      "buy_plots": "Plots & land",
      "query_buy_commercial": "Commercial properties for sale",
      "query_buy_flats": "Flats and apartments for sale",
      "query_buy_plots": "Residential plots and land for sale",
      "query_rent_flats": "Flats and apartments for rent",
      "query_rent_houses": "Independent houses and villas for rent",
      "query_rent_pg": "PG and shared accommodation for rent",
      "query_sell_ai": "I want to sell my property and need help getting started",
      "rent_flats": "Flats for rent",
      "rent_houses": "Houses & villas for rent",
      "rent_pg": "PG & co-living",
      "sell_ai": "Ask AI about selling",
      "sell_list": "List a property"
    },
    "listings": "Listings",
    "listings_count_suffix": "listings",
    "location_permission_dialog": {
      "browser_popup_tip": "If your browser shows a popup asking to know your location, click Allow or Just this time first.",
      "browser_popup_waiting": "Look near the top of your browser for a location popup, then click Allow or Just this time.",
      "desc_denied": "This site cannot use your live location until you allow it.",
      "desc_timeout": "Getting your location took too long.",
      "desc_unavailable": "Your device could not find GPS coordinates right now.",
      "how_to_unblock_android": "Turn on location for this site (Android)",
      "how_to_unblock_desktop": "Turn on location for this site",
      "how_to_unblock_ios": "Turn on location for this site (iPhone / iPad)",
      "how_to_unblock_mac": "Turn on location for this site (Mac)",
      "how_to_unblock_windows": "Turn on location for this site (Windows)",
      "locating": "Checking location…",
      "no_gps_note": "Location could not be found",
      "place_pin_instead": "I will drag the pin on map",
      "search_manually": "Search Locality Manually",
      "step_android_1": "In Chrome, tap the lock icon next to the website address.",
      "step_android_2": "Tap Permissions (or Site settings).",
      "step_android_3": "Set Location to Allow.",
      "step_android_4": "Come back here and tap Try Again.",
      "step_desktop_1": "Click the lock icon to the left of the website address in your browser.",
      "step_desktop_2": "Find Location and set it to Allow.",
      "step_desktop_3": "If needed, turn on Location in your system privacy settings for this browser.",
      "step_desktop_4": "Come back here and click Try Again.",
      "step_ios_1": "In Safari, tap aA (or the page settings icon) on the left of the address bar.",
      "step_ios_2": "Tap Website Settings, then Location.",
      "step_ios_3": "Choose Allow.",
      "step_ios_4": "If it still fails: iPhone Settings → Privacy & Security → Location Services → Safari Websites → Allow.",
      "step_ios_5": "Return here and tap Try Again.",
      "step_mac_1": "Click the lock icon to the left of the website address in your browser.",
      "step_mac_2": "Find Location and set it to Allow.",
      "step_mac_3": "Also check Mac System Settings → Privacy & Security → Location Services is On, and your browser is checked.",
      "step_mac_4": "Come back here and click Try Again.",
      "step_windows_1": "Click the lock icon to the left of the website address in your browser.",
      "step_windows_2": "Find Location and set it to Allow.",
      "step_windows_3": "Also check Windows Settings → Privacy & security → Location is On, and your browser is allowed.",
      "step_windows_4": "Come back here and click Try Again.",
      "timeout_hint": "If a browser location popup appeared, click Allow on it. Otherwise try again, or search your locality by name.",
      "timeout_note": "Location is taking too long",
      "title_denied": "Location Access Blocked",
      "title_generic": "Live Location Unavailable",
      "title_timeout": "Location Request Timed Out",
      "title_unavailable": "Cannot Detect Device Location",
      "try_again": "Try Again",
      "unavailable_hint": "Many laptops cannot get an exact GPS fix. Search your locality by name, or drag the pin on the map."
    },
    "location_picker": {
      "desc": "To provide the best results, we need to know your city. Please allow location access or select your city manually.",
      "footer": "Your country and city help our AI find precise matches in your area.",
      "title": "Location Required"
    },
    "manager": {
      "badge": "Property Managers",
      "desc": "Built for professionals who manage multiple properties — track tenants, automate collections, and grow your rental business from one powerful dashboard.",
      "features": {
        "analytics_desc": "Get real-time insights on occupancy rates, rental income trends, and property performance across your entire portfolio.",
        "analytics_title": "Portfolio Analytics",
        "collections_desc": "Streamline rent collection with automated reminders and payment tracking to maximize on-time payments.",
        "collections_title": "Automated Collections",
        "tenant_desc": "Manage tenant communications, lease renewals, and maintenance requests in one unified place.",
        "tenant_title": "Tenant Relationship Hub"
      },
      "join_btn": "Join as Property Manager",
      "no_commitment": "No commitment required • Set up in minutes",
      "title_1": "Scale Your Portfolio,",
      "title_accent": "Effortlessly."
    },
    "nav_contact": "Contact Us",
    "nav_features": "Features",
    "nav_feedback": "Feedback",
    "nav_get_started": "Get Started",
    "nav_pricing": "Pricing",
    "nav_signin": "Sign In",
    "no_properties_found": "No properties found",
    "owner": {
      "badge": "Property Owners",
      "desc": "Join thousands of owners who list their properties on our AI-powered platform.",
      "post_btn": "Post Property Now",
      "subtitle": "Pay only for what you use with our flexible credit system",
      "title_1": "List your property and find",
      "title_accent": "Verified Tenants Instantly"
    },
    "popular": "Popular:",
    "popular_properties": "Popular Properties",
    "popular_properties_desc": "Find the best deals in your area",
    "popular_properties_prefix": "Popular Properties in",
    "popular_tags": {
      "bhk_apartments": "3BHK Apartments",
      "bhk_in_city": "3BHK in {{city}}",
      "independent_house": "Independent House",
      "pet_friendly": "Pet Friendly",
      "villas_with_pool": "Villas with Pool"
    },
    "preferred_agent": "Preferred Agent",
    "preferred_agents_desc": "Verified property managers trusted by buyers & renters",
    "preferred_agents_prefix": "Preferred Agents in",
    "projects": {
      "badge": "New Launch",
      "card1_desc": "Browse comprehensive details of all newly launched residential and commercial projects in your city.",
      "card1_title": "Directory for All New Projects",
      "card2_desc": "Access official compliance reports, legal approvals, and RERA registration details for safety.",
      "card2_title": "All Reports from RERA",
      "card3_desc": "Get unbiased analysis, investment potential ratings, and construction quality reviews from experts.",
      "card3_title": "Expert Reviews & Advice",
      "desc": "Everything you need to know about upcoming developments, compliance, and expert opinions.",
      "title": "Upcoming Projects"
    },
    "search_placeholder": "Try '3 BHK Villa in Hyderabad' or 'Studio for rent under 15k'...",
    "see_all": "See all",
    "since": "Since",
    "theme": "Theme"
  },
  "leases_page": {
    "actions": {
      "convert": "Convert",
      "reupload_signed": "Re-upload Signed Lease",
      "sign_upload": "Sign & Upload",
      "signed_lease": "Signed Lease",
      "unsigned_lease": "Unsigned Lease",
      "update_lease": "Update Lease",
      "upload_lease": "Upload Lease"
    },
    "add_tenant_btn": "Add Tenant Manually",
    "desc_owner": "Manage your active leases and incoming leads.",
    "desc_tenant": "View your active leases, contract details, and sign documents.",
    "errors": {
      "add_failed": "Failed to add tenant. Please ensure the user exists.",
      "convert_failed": "Failed to convert tenant",
      "delete_failed": "Failed to delete record. Please try again.",
      "update_failed": "Failed to update tenant details",
      "upload_failed": "Failed to upload file"
    },
    "filters": {
      "reset": "Reset",
      "search_placeholder": "Search by name, email, property..."
    },
    "interest_types": {
      "lease": "📝 Lease",
      "rent": "🏠 Rent",
      "sale": "💰 Sale"
    },
    "modals": {
      "add_manual": {
        "adding": "Adding...",
        "cancel": "Cancel",
        "email_hint": "User must be registered with this email.",
        "email_label": "Tenant Email *",
        "email_placeholder": "tenant@example.com",
        "end_label": "Lease End *",
        "no_properties": "No properties found under your control.",
        "property_hint": "Only properties you manage or own are shown.",
        "property_label": "Select Property *",
        "property_placeholder": "Select a property",
        "rent_label": "Monthly Rent (₹) *",
        "start_label": "Lease Start *",
        "submit": "Add Tenant",
        "subtitle": "Add an existing user as an active tenant.",
        "title": "Add Tenant Manually"
      },
      "convert": {
        "cancel": "Cancel",
        "desc": "Set lease details for <1>{{name}}</1> at <3>{{property}}</3>",
        "end_label": "Lease End Date *",
        "rent_label": "Monthly Rent (₹) *",
        "start_label": "Lease Start Date *",
        "submit": "Convert to Tenant",
        "title": "Convert to Active Tenant"
      },
      "delete": {
        "cancel": "Cancel",
        "desc": "Are you sure you want to delete the record for <1>{{name}}</1>?",
        "submit": "Delete Record",
        "title": "Confirm Deletion",
        "warning": "This action cannot be undone."
      },
      "edit": {
        "cancel": "Cancel",
        "desc": "Update lease terms for <1>{{name}}</1>",
        "end_label": "Lease End Date",
        "rent_label": "Monthly Rent (₹)",
        "start_label": "Lease Start Date",
        "submit": "Save Changes",
        "title": "Edit Lease Details",
        "updating": "Saving..."
      },
      "lease_doc": {
        "cancel": "Cancel",
        "desc_sign": "Upload the signed copy of your lease agreement.",
        "desc_upload": "Upload the lease agreement for your tenant to review and sign.",
        "download": "Download",
        "file_hint": "PDF files only, max 5MB",
        "select_pdf": "Select PDF Document",
        "submit_replace": "Replace Document",
        "submit_upload": "Upload Document",
        "template": "Lease Agreement Template",
        "title_sign": "Sign & Upload Lease",
        "title_upload": "Upload Lease Document",
        "upload_hint": "Click to select or drag and drop"
      },
      "view": {
        "close": "Close",
        "labels": {
          "email": "Email Address",
          "end": "Lease End",
          "inquiry": "Initial Inquiry",
          "property": "Property",
          "rent": "Monthly Rent",
          "start": "Lease Start"
        },
        "subtitle": "Viewing details for {{name}}",
        "title": "Tenant Details"
      }
    },
    "status": {
      "active": "Active",
      "application": "Application",
      "inquiry": "Inquiry"
    },
    "table": {
      "actions": "Actions",
      "anonymous_user": "Anonymous User",
      "date": "Date",
      "default_inquiry_message": "I'm interested in this property.",
      "interest_type": "Interest Type",
      "lead_name": "Lead Name",
      "lease_period": "Lease Period",
      "message": "Message",
      "no_active_tenants": "No active tenants found. Check the Inquiries tab?",
      "no_inquiries": "No new inquiries found.",
      "property": "Property",
      "rent": "Rent",
      "status": "Status",
      "tenant": "Tenant",
      "to": "to"
    },
    "tabs": {
      "active": "Active Tenants",
      "inquiries": "Leads & Inquiries"
    },
    "title_owner": "Tenants & Inquiries",
    "title_tenant": "My Leases & Records",
    "toasts": {
      "fill_required": "Please fill in all required fields.",
      "lease_doc_uploaded": "Lease document uploaded successfully!",
      "signed_lease_uploaded": "Signed lease uploaded successfully!",
      "tenant_added": "Tenant added successfully!"
    }
  },
  "listing_questions": {
    "location_set_success": "listing_questions.location_set_success"
  },
  "location": {
    "choose_city": "Choose your city",
    "choose_country": "Choose country",
    "city_label": "City",
    "city_loading": "Loading cities…",
    "country_label": "Country",
    "country_loading": "Loading countries…",
    "just_open_map": "Just open map for {{zoneName}}",
    "no_cities": "No enabled cities found for this country.",
    "no_countries": "No supported countries configured.",
    "search_city": "Search cities…",
    "select_area_in": "Select Area in {{zoneName}}",
    "tap_area_hint": "Tap an area or speak/type your neighborhood below"
  },
  "maintenance": {
    "admin_notice": "Admin access: You can still use the application.",
    "check_back": "Please check back soon. We apologize for any inconvenience.",
    "description": "We're performing scheduled maintenance to improve your experience.",
    "title": "Under Maintenance"
  },
  "maintenance_dashboard": {
    "card": {
      "reported": "Reported:",
      "status": "Status:"
    },
    "empty": {
      "subtitle": "Everything looks good in your portfolio!",
      "title": "No maintenance requests found"
    },
    "filter_status": "Filter Status",
    "filters": {
      "all": "All Requests"
    },
    "modal": {
      "category": "Category",
      "category_placeholder": "What's wrong?",
      "choose_property": "Choose a property",
      "description": "Submit a new repair or maintenance request for one of your managed properties.",
      "description_for_property": "Something need fixing at {{propertyName}}? Let us know.",
      "description_placeholder": "Describe the issue, location in the unit, and any urgent details...",
      "issue_description": "Issue Description",
      "issue_details": "Issue Details",
      "issue_details_placeholder": "Please describe what's happening...",
      "no_properties": "No properties available",
      "priority": "Priority",
      "select_property": "Select Property",
      "submit": "Submit Request",
      "title": "Report a Maintenance Issue"
    },
    "priority_detail": {
      "high": "High - Urgent",
      "low": "Low - Routine",
      "medium": "Medium - Soon",
      "urgent": "Urgent - Emergency"
    },
    "property_fallback": "Property ({{id}}...)",
    "report_issue": "Report Issue",
    "status": {
      "assigned": "Assigned",
      "cancelled": "Cancelled",
      "completed": "Completed",
      "in_progress": "In Progress",
      "pending": "Pending"
    },
    "subtitle": "Track and manage repair requests across your managed properties.",
    "title": "Maintenance Dashboard",
    "toasts": {
      "description_required": "Please provide a description of the issue",
      "fields_required": "Please fill in all required fields",
      "select_property": "Please select a property",
      "status_update_failed": "Failed to update status",
      "status_updated": "Status updated to {{status}}",
      "submit_failed": "Failed to create maintenance request",
      "submit_success": "Maintenance request submitted successfully!"
    }
  },
  "messages_page": {
    "compose_placeholder": "Write your message...",
    "default_agent_message": "Hi! I am interested in your listed properties.",
    "empty_inbox_description": "Select a conversation from the sidebar to view messages about properties.",
    "empty_inbox_title": "Your Inbox",
    "errors": {
      "auth_timeout": "Messaging sign-in timed out. Please refresh the page and try again.",
      "load_failed": "Failed to load conversations. Please refresh and try again.",
      "load_title": "Could not load messages",
      "send_failed": "Failed to send message. Please try again.",
      "start_conversation_failed": "Failed to start conversation. Please try again.",
      "voice_send_failed": "Failed to send voice message. Please try again."
    },
    "fallback_initials": "U",
    "fallback_user": "User",
    "inbox": "Inbox",
    "loading_conversations": "Loading conversations...",
    "login_required": "Please login to view messages",
    "no_history_hint": "Be the first to send a message and start the negotiation process.",
    "no_history_title": "No conversation history",
    "no_results_hint": "Try searching for a name or property",
    "no_results_title": "No results found",
    "privacy_alert": {
      "cancel_edit": "Cancel & Edit",
      "description": "We've detected contact information in your message. For your safety, we recommend keeping all communication within the platform.",
      "preview_label": "Message Preview",
      "send_masked": "Send Masked Message",
      "title": "Privacy Alert"
    },
    "property_card": {
      "badge": "Property",
      "untitled": "Property listing"
    },
    "property_info": {
      "load_failed": "Could not load this property. You can keep chatting.",
      "loading": "Loading property…",
      "missing_id": "No property is linked to this conversation.",
      "open": "About this property"
    },
    "ready_to_chat": "Ready to chat",
    "search_placeholder": "Search conversations...",
    "title": "Messages",
    "voice": {
      "duration": "{{seconds}}s",
      "start": "Record voice message",
      "stop": "Stop recording"
    }
  },
  "not_available": "not_available",
  "notifications": {
    "delete": "Delete",
    "failed_to_delete": "Failed to delete notification",
    "failed_to_load": "Failed to load notifications",
    "failed_to_mark_read": "Failed to mark notification as read",
    "mark_as_read": "Mark as read",
    "new_count_one": "{{count}} New",
    "new_count_other": "{{count}} New",
    "no_notifications": "No notifications",
    "templates": {
      "new_subscription": "A new subscription was purchased!",
      "new_subscription_title": "💰 New Subscription",
      "new_user_registration": "A new user has registered:\n\n👤 Name: {{userName}}\n📧 Email: {{userEmail}}\n🏷️ Role: {{userRole}}\n📝 Type: {{registrationType}}",
      "new_user_registration_title": "🎉 New User Registration"
    },
    "time": {
      "days_ago_one": "{{count}} day ago",
      "days_ago_other": "{{count}} days ago",
      "hours_ago_one": "{{count}} hour ago",
      "hours_ago_other": "{{count}} hours ago",
      "just_now": "just now",
      "minutes_ago_one": "{{count}} minute ago",
      "minutes_ago_other": "{{count}} minutes ago"
    },
    "title": "Notifications"
  },
  "org_billing": {
    "add_credits": "Add Credits to Org",
    "admin_description": "Manage your organization's shared wallet and review usage by members.",
    "contact_admin": "Contact your organization admin to add credits.",
    "last_n_days": "Last {{days}} days",
    "ledger_desc": "Recent credit movements for the organization.",
    "member": "Member",
    "member_description": "View your organization's balance and your usage contribution.",
    "shared_balance": "Shared Wallet Balance",
    "shared_balance_desc": "Credits available for all org members.",
    "shared_balance_note": "Shared across all team members. Usage is deducted from this balance.",
    "title": "Usage & Billing",
    "topup_success": "Credits added to the organization wallet successfully.",
    "usage_summary": "Usage Summary"
  },
  "organizations": {
    "add_user_modal": {
      "add_user": "Add User",
      "cancel": "Cancel",
      "city": "City",
      "creating": "Creating...",
      "description": "Create a new user. The user will receive an email to activate their account.",
      "email": "Email",
      "error_fields": "Please fill in all required fields.",
      "error_org_required": "Organization is required for the selected role.",
      "error_pm_details": "Phone and city are required for property managers.",
      "first_name": "First Name",
      "last_name": "Last Name",
      "organization": "Organization",
      "password": "Password",
      "phone": "Phone Number",
      "role": "Role",
      "select_organization": "Select organization",
      "select_role": "Select role",
      "success": "User created successfully and is now active!",
      "title": "Add User",
      "username": "Username"
    },
    "add_user_to_org": "Add User to Builder",
    "add_user_to_org_modal": {
      "add_user": "Add User",
      "adding": "Adding...",
      "cancel": "Cancel",
      "description": "Add a user to a builder with a specific role. Only super admins can add users to any builder.",
      "error_failed": "Failed to add user to builder",
      "org_admin": "Builder Admin",
      "org_member": "Builder Member",
      "organization": "Builder",
      "role": "Role",
      "select_organization": "Select Builder",
      "select_role": "Select role",
      "title": "Add User to Builder",
      "user": "User"
    },
    "card": {
      "description": "A list of all builders in your system.",
      "title": "All Builders"
    },
    "create_org": "Create Builder",
    "create_org_modal": {
      "cancel": "Cancel",
      "create": "Create Builder",
      "creating": "Creating...",
      "description": "Create a new builder. Only super admins can create builders.",
      "error_failed": "Failed to create builder",
      "org_desc": "Description",
      "org_desc_placeholder": "Enter builder description",
      "org_name": "Builder Name",
      "org_name_placeholder": "Enter builder name",
      "org_slug": "Builder Slug",
      "org_slug_placeholder": "builder-slug",
      "slug_hint": "URL-friendly identifier for the builder",
      "title": "Create Builder"
    },
    "delete_org_modal": {
      "confirm": "Delete \"{{name}}\"?",
      "delete_btn": "Delete Builder",
      "deleting": "Deleting...",
      "details_title": "Builder Details",
      "error_failed": "Failed to delete builder. Please try again.",
      "impact_members": "All builder members (orphaned)",
      "impact_properties": "All builder properties and data",
      "title": "Delete Builder",
      "warning": "This action cannot be undone. All data associated with this builder will be permanently deleted."
    },
    "edit_org_modal": {
      "desc_placeholder": "Enter builder description",
      "description": "Update builder details.",
      "error_failed": "Failed to update builder",
      "name_label": "Builder Name",
      "name_placeholder": "Enter builder name",
      "slug_label": "Builder Slug",
      "slug_placeholder": "builder-slug",
      "title": "Edit Builder"
    },
    "errors": {
      "fetch_failed": "Failed to fetch builders."
    },
    "invite_org_modal": {
      "cancel": "Cancel",
      "description": "Send an invitation email to set up a new builder",
      "email_label": "Email Address",
      "email_placeholder": "Enter email address",
      "error_generic": "An error occurred while sending the invitation.",
      "error_invalid_email": "Please enter a valid email address.",
      "message_label": "Message (Optional)",
      "message_placeholder": "Add a personal message to the invitation...",
      "send": "Send Invitation",
      "sending": "Sending...",
      "success_message": "Invitation sent successfully to {{email}}",
      "title": "Invite to Set Up Builder"
    },
    "invite_to_setup": "Invite to Set Up Builder",
    "loading": "Loading builders...",
    "search_placeholder": "Search builders...",
    "subtitle": "Manage builders and their settings.",
    "table": {
      "actions": "Actions",
      "created": "Created",
      "id": "ID",
      "name": "Name",
      "verified": "Verified"
    },
    "title": "Builders",
    "total": "Total",
    "users": {
      "card": {
        "description": "A list of all users in your organization.",
        "title": "Organization Members"
      },
      "fetch_failed": "Failed to fetch organization users.",
      "filters": {
        "all_status": "All Status",
        "invited": "Invited"
      },
      "invite": "Invite User",
      "remove": "Remove user",
      "search_placeholder": "Search users...",
      "status": {
        "invited": "Invited"
      },
      "subtitle": "Manage users in your organization.",
      "table": {
        "actions": "Actions",
        "created": "Created",
        "name": "Name",
        "role": "Role",
        "status": "Status",
        "username": "Username",
        "verified": "Verified"
      },
      "title": "Organization Users",
      "total": "Users Total"
    }
  },
  "owner_stats": {
    "active_now": "Active Now",
    "manage_all": "Manage All Listings",
    "post_new": "Post New Listing",
    "total_listings": "Total Listings",
    "total_views": "Total Views"
  },
  "payment_success": {
    "actions": {
      "go_to_dashboard": "Go to Dashboard",
      "go_to_plans": "Go to Plans",
      "manage_subscription": "Manage Subscription"
    },
    "error_state": {
      "title": "Payment Verification Failed"
    },
    "errors": {
      "no_payment_info": "No payment information provided",
      "unknown": "An unknown error occurred.",
      "verification_failed": "Payment verification failed"
    },
    "loading": {
      "description": "Please wait while we confirm your subscription.",
      "title": "Verifying your payment..."
    },
    "subscription_details": {
      "billing_cycle": "Billing Cycle",
      "next_billing_date": "Next Billing Date",
      "plan": "Plan",
      "status": "Status",
      "title": "Subscription Details"
    },
    "success_state": {
      "description": "Your payment has been processed successfully and your subscription is now active. You can start using all the features included in your plan.",
      "subtitle": "Thank you for your subscription",
      "title": "Payment Successful!"
    }
  },
  "plans": {
    "add_plan_btn": "Add Plan",
    "autogenerate_btn": "Autogenerate Plans",
    "description": "Manage your subscription plans and pricing.",
    "no_plans": {
      "description": "Get started by creating your first plan or autogenerate some default plans.",
      "title": "No plans"
    },
    "search_placeholder": "Search plans...",
    "table": {
      "description": "A list of all subscription plans in your system.",
      "title": "All Plans"
    },
    "title": "Plans",
    "types": {
      "business": "Business",
      "single": "Single"
    }
  },
  "pricing_page": {
    "ai_smart_search_card": {
      "ai_powered": "AI POWERED",
      "cta": "Start Searching",
      "deep_insights": "Deep Insights",
      "desc": "Harness the power of AI to find exactly what you need in seconds.",
      "feature1": "Natural Language Queries",
      "feature2": "Neighborhood Analysis",
      "feature3": "Market Trend Data",
      "feature4": "Local Insights & Scores",
      "feature5": "Save Search Preferences",
      "intelligence": "Intelligence",
      "title": "AI Smart Search"
    },
    "badge": "Flexible Pricing",
    "buy_credits_card": {
      "any_amount": "Any Amount",
      "badge": "FLEXIBLE",
      "cta": "Top Up Now",
      "feature1": "Secure Stripe Payments",
      "feature2": "Instant Balance Update",
      "feature3": "Use for all AI features",
      "feature4": "No Monthly Commitments",
      "feature5": "Full Transaction History",
      "never_expires": "NEVER EXPIRES",
      "subtext": "Add balance to your wallet starting from as low as $0.50 USD.",
      "title": "Buy Credits",
      "validity": "Validity"
    },
    "desc": "Buy credits as you go. No monthly commitments, no hidden fees. All premium AI features included with every top-up.",
    "property_listings_card": {
      "cta": "List Property",
      "desc": "Use credits to list your properties and reach thousands of verified buyers.",
      "exposure": "Exposure",
      "feature1": "Verified Owner Badge",
      "feature2": "Unlimited Inquiries",
      "feature3": "Lead Management Tools",
      "feature4": "Smart Lead Filtering",
      "feature5": "Direct Messaging",
      "high_visibility": "HIGH VISIBILITY",
      "list_reach": "List & Reach",
      "title": "Property Listings"
    },
    "title": "Simple, Credit-Based Pricing"
  },
  "privacy_policy": {
    "last_updated": "Last updated: October 29, 2026",
    "sections": {
      "ai": {
        "body_1": "LetMeIn AI uses artificial intelligence and machine learning technologies to deliver core features of the platform. This includes:",
        "body_2_prefix": "You have the right to request human review of any automated processing that materially affects you. Contact us at",
        "body_2_suffix": "to make such a request.",
        "items": {
          "image_search": {
            "label": "Image Search:",
            "value": "If you use image-based property search, uploaded images are analyzed by AI/embedding models to identify property characteristics. Images used only for a one-off search request are not kept as permanent listing media unless you separately upload them to a listing."
          },
          "listing_assistant": {
            "label": "Listing Assistant (GenUI):",
            "value": "When you use conversational listing tools, messages and extracted listing fields are processed to build and update your draft or published listing."
          },
          "natural_language": {
            "label": "Natural Language Search:",
            "value": "Your search and listing prompts may be processed by large language models (including Google Gemini and related AI services) to interpret intent and generate responses. Prompt text may be sent to those providers under their data processing terms."
          },
          "recommendations": {
            "label": "Recommendations:",
            "value": "We use aggregated behavioral data to generate personalized property recommendations. No individual profiling is used for automated decisions that significantly affect your rights."
          },
          "voice_input": {
            "label": "Voice Input:",
            "value": "If you use voice search or voice listing input, audio is converted to text via speech services such as Sarvam AI and/or the browser Web Speech API. We do not permanently retain raw audio recordings. Transcripts may be cached briefly; duration and provider usage may be logged for billing and reliability."
          }
        },
        "title": "5. AI & Automated Processing"
      },
      "changes": {
        "body_1": "We may update this Privacy Policy from time to time to reflect changes in our practices, technology, legal requirements, or other factors. When we make material changes, we will:",
        "body_2": "Your continued use of LetMeIn AI after the effective date of any changes constitutes your acceptance of the revised policy. If you do not agree, you may delete your account at any time.",
        "items": {
          "email_notice": "Send an email notification to registered users at least 14 days before the changes take effect.",
          "last_updated": "Update the \"Last updated\" date at the top of this page.",
          "platform_notice": "Display a prominent notice on the platform for at least 30 days."
        },
        "title": "13. Changes to This Privacy Policy"
      },
      "children": {
        "body_prefix": "LetMeIn AI is not directed at or intended for use by individuals under the age of 18. We do not knowingly collect personal information from minors. If you are a parent or guardian and believe your child has provided personal information to us, please contact us immediately at",
        "body_suffix": "and we will promptly delete such data.",
        "title": "11. Children's Privacy"
      },
      "collect": {
        "payment": {
          "body": "We use Stripe as our payment processor for subscriptions, plan changes, and credit/wallet top-ups where enabled. We do not store your full credit or debit card details on our servers. Stripe collects and processes payment data in accordance with PCI-DSS standards. We retain transaction IDs, plan or credit purchase details, wallet balance metadata, and billing history needed for accounting and support.",
          "title": "2.4 Payment Information"
        },
        "personal": {
          "body": "We collect personal information that you voluntarily provide when registering on our platform, including:",
          "items": {
            "credentials": "Username and encrypted password credentials",
            "location": "City, state, and country of residence",
            "name_contact": "Full name, email address, and phone number",
            "organization": "Organization or builder name and related business account details (for org / business accounts)",
            "photo": "Profile photo (if provided)",
            "verification": "Identity verification details when enabled for your account (for example, Aadhaar verification via DigiLocker through our verification partner). We store limited verification status and, where provided, masked identifiers such as the last four digits—not your full Aadhaar number on our servers."
          },
          "title": "2.1 Personal Information"
        },
        "property": {
          "body": "If you are a property owner or manager, we collect details about the properties you list:",
          "items": {
            "address": "Property address, location coordinates, and locality details",
            "details": "Property type, size, number of rooms, and amenities",
            "history": "Tenant history and lease agreement metadata",
            "import_sources": "Listing content you import (for example spreadsheet rows, free-text paragraphs, or property portal URLs you submit for scraping/enrichment)",
            "media": "Photographs, videos, documents, and virtual tour content uploaded for listings",
            "pricing": "Pricing, rental terms, and availability information"
          },
          "title": "2.2 Property Information"
        },
        "title": "2. Information We Collect",
        "usage": {
          "body": "When you use our platform, we automatically collect certain technical information:",
          "items": {
            "behavior": "Pages viewed, time spent on pages, and navigation paths",
            "device": "IP address, browser type, device type, and operating system",
            "diagnostics": "Application error and performance diagnostics (for example via Sentry), which may include technical context needed to fix issues",
            "location_data": "Location data (city-level), if you grant permission",
            "maps": "Map interactions and geocoding requests (for example Google Maps / Places) when you set or search locations, including approximate coordinates you confirm on a map pin",
            "messages": "In-app notifications and message delivery metadata when realtime messaging features are enabled",
            "referral": "Referral source and UTM campaign parameters",
            "search_queries": "Search queries entered into our AI search engine",
            "voice": "Voice input used for search or listing: audio is streamed or uploaded for speech-to-text (for example Sarvam AI or on-device Web Speech). We do not permanently store raw audio files. Transcript text may be cached briefly (typically up to about 30 minutes) to improve reliability, and usage metrics (such as duration) may be logged for billing and quality."
          },
          "title": "2.3 Usage & Technical Data"
        }
      },
      "contact": {
        "body": "If you have any questions, concerns, or complaints about this Privacy Policy or our data practices, please contact our Privacy Team:",
        "email": "Email:",
        "security": "Security issues:",
        "sla": "We aim to respond to all privacy-related requests within 30 calendar days.",
        "support": "General support:",
        "team": "LetMeIn AI — Privacy Team",
        "title": "14. Contact Us"
      },
      "cookies": {
        "body_1": "We use cookies and similar tracking technologies to enhance your experience on LetMeIn AI. Cookies are small data files stored on your device that help us remember your preferences and understand how you interact with our platform.",
        "body_2": "You can control cookies through your browser settings. Note that disabling certain cookies may affect the functionality of parts of our platform.",
        "items": {
          "analytics": {
            "label": "Analytics Cookies:",
            "value": "Help us understand user behavior and improve the platform. We use anonymized data only."
          },
          "essential": {
            "label": "Essential Cookies:",
            "value": "Required for the platform to function properly (e.g., authentication tokens, session management). These cannot be disabled."
          },
          "preference": {
            "label": "Preference Cookies:",
            "value": "Store your settings such as selected city, language preference, and theme mode (light/dark)."
          },
          "third_party": {
            "label": "Third-Party Cookies:",
            "value": "Some features (e.g., Google Maps, Firebase) may set their own cookies governed by their respective privacy policies."
          }
        },
        "title": "4. Cookies & Tracking Technologies",
        "types_title": "Types of Cookies We Use"
      },
      "introduction": {
        "body_1": "Welcome to LetMeIn AI. We are an AI-powered real estate platform connecting property seekers, owners, organizations, and property managers. We primarily operate in India and may support additional markets when enabled for your account. We are committed to protecting your personal information and your right to privacy.",
        "body_2": "This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website, use our mobile application, or interact with our services. Please read this policy carefully. If you disagree with its terms, please discontinue use of our platform.",
        "title": "1. Introduction"
      },
      "retention": {
        "body_1": "We retain your personal data only for as long as necessary to fulfill the purposes outlined in this policy, or as required by applicable law.",
        "body_2": "Upon account deletion, we will anonymize or delete your personal data from our active systems unless a longer retention period is legally required.",
        "items": {
          "account": {
            "label": "Account Data:",
            "value": "Retained for the lifetime of your account and up to 90 days after account deletion, to allow account recovery and resolve disputes."
          },
          "listings": {
            "label": "Property Listings:",
            "value": "Archived for up to 1 year after being removed or expired, for analytics and dispute resolution."
          },
          "logs": {
            "label": "Activity Logs:",
            "value": "Retained for 6 months for security monitoring purposes."
          },
          "marketing": {
            "label": "Marketing Data:",
            "value": "Retained until you opt out, after which it is deleted within 30 days."
          },
          "transactions": {
            "label": "Transaction Records:",
            "value": "Retained for 7 years (or as required by applicable financial and tax rules), including credit/wallet purchase records."
          },
          "voice": {
            "label": "Voice Transcripts:",
            "value": "Raw audio is not permanently stored by us. Short-lived transcript cache entries (when enabled) typically expire within about 30 minutes."
          }
        },
        "title": "7. Data Retention"
      },
      "rights": {
        "body_1": "Depending on your location and applicable law—including India’s Digital Personal Data Protection Act, 2023 (DPDP) where it applies—you may have the following rights with respect to your personal data:",
        "body_2_prefix": "To exercise any of these rights, please contact us at",
        "body_2_suffix": "We will respond within 30 days. We may need to verify your identity before fulfilling certain requests.",
        "items": {
          "access": {
            "label": "Right to Access:",
            "value": "Request a copy of the personal data we hold about you."
          },
          "erasure": {
            "label": "Right to Erasure:",
            "value": "Request deletion of your personal data (subject to legal retention requirements)."
          },
          "object": {
            "label": "Right to Object:",
            "value": "Object to processing of your data for direct marketing or profiling purposes."
          },
          "portability": {
            "label": "Right to Data Portability:",
            "value": "Request your data in a machine-readable format."
          },
          "rectification": {
            "label": "Right to Rectification:",
            "value": "Request correction of inaccurate or incomplete data."
          },
          "restriction": {
            "label": "Right to Restriction:",
            "value": "Request that we limit how we process your data in certain circumstances."
          },
          "withdraw": {
            "label": "Right to Withdraw Consent:",
            "value": "Where processing is based on your consent, withdraw it at any time without affecting prior processing."
          }
        },
        "title": "9. Your Privacy Rights"
      },
      "security": {
        "body_1": "We implement industry-standard security measures to protect your personal information from unauthorized access, disclosure, alteration, and destruction:",
        "body_2_prefix": "Despite our best efforts, no data transmission over the internet or storage system can be guaranteed 100% secure. If you believe your account has been compromised, please contact us immediately at",
        "items": {
          "access": "Access to user data by our team is strictly role-based and logged.",
          "audits": "Regular security audits and vulnerability assessments are conducted on our platform.",
          "https": "All data is transmitted over HTTPS with TLS 1.2+ encryption.",
          "infrastructure": "Our infrastructure is hosted on secure, compliant cloud providers with SOC 2 certifications.",
          "passwords": "Passwords are hashed using bcrypt with a strong salt factor and are never stored in plain text.",
          "tokens": "Authentication tokens (JWTs) are short-lived and refreshed securely."
        },
        "title": "8. Data Security"
      },
      "sharing": {
        "body": "We do not sell, trade, or rent your personal information to third parties. We may share your data in the following limited circumstances:",
        "items": {
          "business": {
            "label": "Business Transfers:",
            "value": "In the event of a merger, acquisition, or sale of all or part of our assets, your data may be transferred as part of that transaction. We will notify you before your data is subject to a different privacy policy."
          },
          "consent": {
            "label": "With Your Consent:",
            "value": "In any other circumstances, we will obtain your explicit consent before sharing your personal data."
          },
          "legal": {
            "label": "Legal Requirements:",
            "value": "If required by law, court order, or governmental authority, we may disclose your information to comply with such obligations."
          },
          "listings": {
            "label": "Property Listings:",
            "value": "When you list a property, your listing details (property info, contact city) are visible to other users on the platform. Personal contact details are shared only when a user expresses interest, and only if you have enabled this in your settings."
          },
          "providers": {
            "label": "Service Providers:",
            "value": "With trusted vendors who assist in operating our platform (for example Stripe for payments, Firebase/Google for authentication and AI, AWS for hosting and media storage, Sarvam AI for speech-to-text, Google Maps for location services, Pusher for realtime notifications, and error-monitoring providers such as Sentry), under appropriate contractual safeguards."
          }
        },
        "title": "6. Sharing Your Information"
      },
      "third_party": {
        "body_1": "Our platform integrates with the following third-party services. Each has its own privacy policy that governs how they handle data:",
        "body_2": "We are not responsible for the privacy practices of these third-party services. We encourage you to review their policies before using connected features.",
        "items": {
          "aws": {
            "label": "Amazon Web Services (AWS):",
            "link_text": "AWS Privacy",
            "value": "Application hosting and object storage / CDN for property media (for example via S3 and CloudFront on media.letmein.ai)."
          },
          "facebook": {
            "label": "Facebook (Meta):",
            "link_text": "Meta Privacy Policy",
            "value": "Optional social login via Facebook OAuth when enabled."
          },
          "google": {
            "label": "Google (Firebase, Gemini AI & Maps):",
            "link_text": "Google Privacy Policy",
            "value": "Authentication, App Check / reCAPTCHA, AI-powered search and listing assistance, and Maps / Places / geocoding features."
          },
          "pusher": {
            "label": "Pusher:",
            "link_text": "Pusher Privacy Policy",
            "value": "Realtime in-app notifications and presence when messaging features are enabled."
          },
          "sarvam": {
            "label": "Sarvam AI:",
            "link_text": "Sarvam",
            "value": "Speech-to-text for voice search and voice listing input when Sarvam is enabled for your deployment."
          },
          "sentry": {
            "label": "Sentry:",
            "link_text": "Sentry Privacy Policy",
            "value": "Application error and performance monitoring to keep the service reliable."
          },
          "stripe": {
            "label": "Stripe:",
            "link_text": "Stripe Privacy Policy",
            "value": "Payment processing for subscriptions and credit/wallet top-ups."
          },
          "surepass": {
            "label": "Surepass / DigiLocker (when enabled):",
            "link_text": "Partner terms",
            "value": "Optional Aadhaar / DigiLocker identity verification for eligible accounts."
          }
        },
        "title": "10. Third-Party Services"
      },
      "transfers": {
        "body_1": "LetMeIn AI is primarily operated from India. Some third-party providers (such as Google, Stripe, AWS, Sarvam, Sentry, or Pusher) may process data in other countries, including the United States and the European Union. When we transfer personal data internationally, we take steps to ensure adequate protections are in place, including:",
        "items": {
          "compliance": "Ensuring our partners comply with applicable global data protection standards.",
          "dpas": "Signing data processing agreements (DPAs) with our third-party processors.",
          "frameworks": "Using providers covered by appropriate international data transfer frameworks."
        },
        "title": "12. International Data Transfers"
      },
      "use": {
        "body": "We use the information we collect for the following purposes:",
        "items": {
          "account_management": {
            "label": "Account Management:",
            "value": "To create and manage your account, authenticate your identity, and maintain session security."
          },
          "ai_matching": {
            "label": "AI Matching:",
            "value": "To power personalized property recommendations, AI search, conversational listing assistants (GenUI), embeddings-based matching, and related natural language features."
          },
          "analytics": {
            "label": "Analytics:",
            "value": "To analyze usage patterns and improve the platform's performance, design, and feature set."
          },
          "communications": {
            "label": "Communications:",
            "value": "To send transactional emails (e.g., email verification, password reset, booking confirmations) and service notifications."
          },
          "fraud_prevention": {
            "label": "Fraud Prevention:",
            "value": "To detect, prevent, and investigate fraudulent activity, security breaches, and abuse of our platform."
          },
          "legal_compliance": {
            "label": "Legal Compliance:",
            "value": "To comply with applicable laws, regulations, and legal obligations."
          },
          "listing_tools": {
            "label": "Listing & Import Tools:",
            "value": "To help you create and manage listings, including AI-assisted listing chat and optional import from files or property URLs you provide."
          },
          "marketing": {
            "label": "Marketing:",
            "value": "To send promotional updates and special offers, if you have opted in. You may unsubscribe at any time."
          },
          "payment_processing": {
            "label": "Payment Processing:",
            "value": "To manage subscriptions and credit/wallet purchases, process upgrades or top-ups, and track usage-based billing (including AI, voice, and maps usage where metered)."
          },
          "service_delivery": {
            "label": "Service Delivery:",
            "value": "To provide, operate, and improve our AI-powered property search and listing services."
          }
        },
        "title": "3. How We Use Your Information"
      }
    },
    "summary": "This Privacy Policy describes how LetMeIn AI (\"we\", \"us\", or \"our\") collects, uses, stores, and protects your personal information when you use our website, apps, and services. By using LetMeIn AI, you agree to the practices described in this policy.",
    "title": "Privacy Policy"
  },
  "profile": {
    "account_settings": "Account Settings",
    "add_area_placeholder": "Add an area (e.g. Hitech City)",
    "add_manually": "Add as custom area anyway",
    "appearance": "Appearance",
    "appearance_settings": "Appearance Settings",
    "appearance_tab": {
      "auto_save": "Auto-Save Enabled",
      "auto_save_desc": "Your theme preference is automatically saved and will be applied across all your sessions.",
      "theme_mode": "Theme Mode",
      "theme_mode_desc": "Toggle between light and dark theme",
      "theme_pref": "Theme Preferences",
      "theme_pref_desc": "Switch between light and dark mode"
    },
    "basic_profile_info": "Your basic profile information",
    "billing_locale": "Billing & Wallet",
    "billing_locale_desc": "Set at registration. Contact support to change after your wallet is in use.",
    "confirm_new_password": "Confirm New Password",
    "connected_accounts": "Connected Accounts",
    "control_notifications": "Control how you receive notifications",
    "customize_look_feel": "Customize the look and feel of your application",
    "default_location": "Default Location",
    "edit_profile": "Edit Profile",
    "email_address": "Email Address",
    "enter_new_password_placeholder": "Enter new password",
    "enter_old_password_placeholder": "Enter your old password",
    "first_name": "First Name",
    "identity": {
      "card_desc": "Your Aadhaar details are used only for identity verification and are not shared publicly.",
      "card_title": "Aadhaar verification",
      "consent": "I consent to Aadhaar verification for identity purposes on LetMeIn AI.",
      "consent_required": "Please accept the consent to continue.",
      "description": "Verify your identity using Aadhaar to build trust on the platform.",
      "digilocker_hint": "You will be redirected to DigiLocker to complete Aadhaar OTP verification securely.",
      "info": "Verification helps owners, tenants, and property managers establish trust for listings and interactions.",
      "masked_aadhaar": "Aadhaar ending in {{lastFour}}",
      "pending": "Verification is in progress. We are checking status...",
      "status_failed": "Unable to fetch verification status.",
      "status_unverified": "Not verified",
      "status_verified": "Verified",
      "tab_label": "Identity",
      "title": "Identity verification",
      "verified_message": "Your Aadhaar identity has been verified.",
      "verify_failed": "Aadhaar verification failed. Please try again.",
      "verify_success": "Aadhaar verified successfully.",
      "verify_with_digilocker": "Verify with DigiLocker",
      "verifying": "Verifying..."
    },
    "last_name": "Last Name",
    "location_tab": {
      "loc_pref": "Location Preferences",
      "loc_pref_desc": "Set your preferred country and city",
      "privacy": "Privacy Information",
      "privacy_desc": "Your location preference is stored locally in your browser. This setting helps us tailor your experience without storing precise GPS data on our servers.",
      "save_prefs": "Save Preferences"
    },
    "manage_auth_methods": "Manage your authentication methods and social login connections",
    "manage_location_prefs": "Manage your default country and city preferences",
    "manage_org_public_info": "Manage your organization's public information",
    "manage_profile_preferences": "Manage your profile and preferences",
    "messages": {
      "account_link_failed": "Failed to link {{provider}} account",
      "account_linked": "{{provider}} account linked successfully!",
      "account_unlink_failed": "Failed to unlink {{provider}} account",
      "account_unlinked": "{{provider}} account unlinked successfully!",
      "enter_old_password": "Please enter your old password.",
      "location_invalid": "Please choose a supported city in your country.",
      "location_update_failed": "Failed to update location preferences",
      "location_updated": "Location preferences updated successfully",
      "notification_permission_blocked": "Notifications are blocked. Please enable them in your browser settings.",
      "notification_permission_denied": "Notification permission denied",
      "notification_update_failed": "Failed to update notification preferences",
      "notification_update_success": "Notification preferences updated successfully!",
      "notifications_not_supported": "Browser notifications are not supported in this browser",
      "old_password_incorrect": "Old password is incorrect.",
      "passwords_do_not_match": "Passwords do not match.",
      "profile_update_failed": "Failed to update profile. Please try again.",
      "profile_updated": "Profile updated successfully!",
      "sw_not_supported": "Service Workers not supported in this browser",
      "unlink_confirm": "Are you sure you want to unlink your {{provider}} account?",
      "web_push_disabled": "Browser notifications disabled",
      "web_push_enabled": "Browser notifications enabled successfully",
      "web_push_failed": "Failed to enable browser notifications"
    },
    "new_password": "New Password",
    "no_areas_added": "No areas added yet. Add areas where you operate.",
    "no_matching_areas": "No matching areas found for",
    "notification_preferences": "Notification Preferences",
    "notifications": "Notifications",
    "notifications_tab": {
      "email": "Email Notifications",
      "email_desc": "Receive notifications via email",
      "in_app": "In-App Notifications",
      "in_app_desc": "Receive notifications within the application",
      "settings_desc": "Manage your notification preferences",
      "settings_title": "Notification Settings",
      "storage_desc": "Your notification preferences are securely stored in your account and will be applied across all your devices.",
      "storage_title": "Preference Storage",
      "web_push": "Browser Notifications",
      "web_push_desc": "Receive notifications even when the app is closed"
    },
    "old_password": "Old Password",
    "operating_areas": "Operating Areas",
    "operating_areas_desc": "List the specific areas where you provide property management services",
    "org_tab": {
      "address": "Address",
      "description": "Description",
      "name": "Organization Name",
      "phone": "Phone",
      "save_details": "Save Details",
      "slug": "Slug",
      "website": "Website"
    },
    "organization": "Organization",
    "organization_profile": "Organization Profile",
    "password_settings": "Password Settings",
    "personal_details": "Personal Details",
    "profile": "Profile",
    "profile_information": "Profile Information",
    "reenter_new_password_placeholder": "Re-enter new password",
    "regional_settings": "Regional Settings",
    "set_password_placeholder": "Set your password",
    "social_account": "Social Account",
    "social_tab": {
      "auth_methods": "Authentication Methods",
      "auth_methods_desc": "Link or unlink authentication providers",
      "connected": "Connected",
      "link": "Link",
      "linking": "Linking...",
      "no_providers": "No providers found",
      "not_connected": "Not connected",
      "providers": {
        "email": "Email/Password",
        "facebook": "Facebook",
        "google": "Google",
        "phone": "Phone"
      },
      "set_password": "Set Account Password",
      "set_password_btn": "Set Password",
      "set_password_desc": "Add a password to enable email/password login in addition to social login.",
      "unlink": "Unlink"
    },
    "update_profile_info": "Update your personal information and account settings"
  },
  "property": {
    "add_to_favourites": "Add to Favourites",
    "address": "Address",
    "age_const": "Age of Construction",
    "amenities_count_one": "{{count}} amenities & features — view for details",
    "amenities_count_other": "{{count}} amenities & features — view for details",
    "amenities_title": "Key Amenities",
    "apartment_name": "Apartment Name",
    "area_type": "Area Type",
    "available_floors": "Available Floors",
    "available_from": "Available / Move-in",
    "available_services": "Available Services",
    "back_to_my_properties": "Back to My Properties",
    "back_to_properties": "Back to Listing Page",
    "balconies": "Balconies",
    "bathrooms": "Bathrooms",
    "baths_one": "{{count}} Bath",
    "baths_other": "{{count}} Baths",
    "bedrooms": "Bedrooms",
    "brochure": "Download Brochure",
    "built_up_area": "Built-Up Area",
    "by_owner": "by {{name}}",
    "collapse_room_details": "Collapse room details",
    "commercial_subtype": "Commercial Subtype",
    "common_area_amenities_title": "Common Area Amenities",
    "compare": "Compare Projects",
    "connectivity_title": "Connectivity & Transit",
    "contact_failed": "Failed to start conversation. Please try again.",
    "contact_loc": "Contact for exact location",
    "contact_owner": "Contact Owner",
    "contact_unavailable": "Contact information is not available for this property.",
    "corner_shop": "Corner Shop",
    "curfew": "Curfew: {{time}}",
    "default_description": "Welcome to this beautiful property. Well-maintained and located in a prime area, it offers the perfect balance of comfort and convenience. Contact us for more details and to schedule a visit.",
    "delete": "Delete",
    "deposit": "Deposit",
    "desc_title": "Property Description",
    "dev_owner": "Developer / Owner",
    "developer": "Developer",
    "dimensions": "Dimensions",
    "directions": "Directions",
    "edit": "Edit",
    "expand_room_details": "Expand room details",
    "external_source": "Original Website",
    "extra_parameters_title": "Extra Parameters",
    "facing": "Facing Direction",
    "favourite": "Favourite",
    "fit_out": "Fit-out Status",
    "floor": "Floor",
    "floor_details": "Floor Details",
    "floor_level": "Floor Level",
    "floor_n": "Floor {{n}}",
    "floor_out_of": "Floor {{n}} (out of {{total}})",
    "food_available": "Food Available",
    "food_meals": "Food & Meals",
    "for": "for",
    "for_rent": "For Rent",
    "for_sale": "For Sale",
    "furnishing": "Furnishing",
    "furnishing_status": "Furnishing Status",
    "gate_curfew": "Gate Curfew",
    "get_contact": "Get Phone & Address",
    "go_back": "Go Back",
    "ground": "Ground",
    "highlights_title": "Extra Parameters",
    "house_rules": "House Rules",
    "immediate": "Immediate",
    "in": "in",
    "individual": "Individual",
    "lifts": "Lifts / Elevators",
    "listing_date": "Listing Date",
    "loc_not_spec": "Location not specified",
    "login_contact": "Please login to contact the owner",
    "login_favourites": "Please login to add to favourites",
    "main_road_facing": "Main Road Facing",
    "maintenance_charges": "Maintenance Charges",
    "maintenance_included": "Maintenance Included",
    "map_pin_hidden": "Hidden from search map",
    "map_pin_visible": "Visible on search map",
    "media_next": "Next media",
    "media_play": "Play video",
    "media_previous": "Previous media",
    "monthly": "Monthly",
    "more_details_title": "More Details",
    "move_in": "Move-in",
    "na": "N/A",
    "nearby_places_title": "Nearby Places",
    "negotiable": "Negotiable",
    "no_curfew": "No Curfew",
    "no_food": "No Food",
    "no_image": "No Image",
    "no_photos": "No Photos Available",
    "not_found": "Property Not Found",
    "not_specified": "Not Specified",
    "open_full_page": "Open full property page",
    "out_of": "Out of",
    "out_of_total": "(out of {{total}})",
    "parking": "Parking",
    "parking_spaces_one": "{{count}} Space",
    "parking_spaces_other": "{{count}} Space",
    "parking_spaces_plural_one": "{{count}} Spaces",
    "parking_spaces_plural_other": "{{count}} Spaces",
    "per_bed_mo": "/bed/mo",
    "pg_avail_from": "Avail: {{date}}",
    "pg_available_for_all": "All Tenants",
    "pg_available_for_anyone": "Co-ed / Anyone",
    "pg_available_for_boys": "Boys Only",
    "pg_available_for_girls": "Girls Only",
    "pg_bed_sharing": "{{count}} Bed Sharing",
    "pg_food_3_meals": "3 Meals Included ({{meals}})",
    "pg_food_included": "Food Included",
    "pg_food_meals_included": "{{meals}} Included",
    "pg_food_self_cooking": "Self Cooking / No Food",
    "pg_name": "PG Name",
    "pg_present_in": "PG Is Present In",
    "pg_rooms_one_one": "{{count}} Room",
    "pg_rooms_one_other": "{{count}} Room",
    "pg_rooms_other_one": "{{count}} Rooms",
    "pg_rooms_other_other": "{{count}} Rooms",
    "pg_service_laundry": "Laundry",
    "pg_service_room_cleaning": "Room Cleaning",
    "pg_service_warden": "Warden Facility",
    "pg_sharing_named": "{{name}} Sharing",
    "pg_usps": "Unique Selling Points",
    "pg_usps_sub": "Key highlights and advantages of this PG accommodation",
    "photo_one_one": "{{count}} photo",
    "photo_one_other": "{{count}} photo",
    "photo_other_one": "{{count}} photos",
    "photo_other_other": "{{count}} photos",
    "plot_area": "Plot Area",
    "poc": "Point of Contact",
    "preferred_tenants": "Preferred Tenants",
    "price_breakup": "Price Breakup",
    "price_rent": "For Rent",
    "price_sale": "For Sale",
    "property_name": "Property / Project Name",
    "property_sub_type": "Property Sub-Type",
    "property_type": "Property Type",
    "ready_to_move": "Ready to Move",
    "remove_from_favourites": "Remove from Favourites",
    "rent": "Rent",
    "rera_approved": "RERA Approved",
    "room_facilities_title": "Room Facilities",
    "room_photos": "Room Photos",
    "room_photos_empty": "No room photos uploaded for this sharing option yet",
    "room_type": "Room Type",
    "sale": "Sale",
    "search_map_pin": "Search Map Pin",
    "security_deposit": "Security Deposit",
    "share": "Share",
    "share_copied": "Copied",
    "share_copy_failed": "Could not copy link",
    "share_copy_link": "Copy link",
    "share_default_title": "Check out this property on LetMeIn AI",
    "share_device": "Share via device…",
    "share_facebook": "Facebook",
    "share_instagram": "Instagram",
    "share_instagram_copied": "Link copied — paste it in Instagram",
    "share_link_copied": "Link copied",
    "share_whatsapp": "WhatsApp",
    "shared_room": "Shared Room",
    "sharing": "Room Sharing",
    "source": "Source",
    "status": "Status",
    "suitable_for": "Suitable For",
    "super_area": "Built-Up Area",
    "total_floors": "Total Floors",
    "total_views": "Total Views",
    "truck_access": "Truck Access",
    "types": {
      "agricultural_land": "Agricultural Land",
      "apartment": "Apartment",
      "builder_floor_apartment": "Builder Floor Apartment",
      "bungalow": "Bungalow",
      "co_living_space": "Co-living Space",
      "commercial": "Commercial",
      "commercial_plot": "Commercial Plot",
      "development_land": "Development Land",
      "duplex_house": "Duplex House",
      "farm_house": "Farm House",
      "farm_land": "Farm Land",
      "gated_community_house": "Gated Community House",
      "gated_community_villa": "Gated Community Villa",
      "hostel": "Hostel",
      "house": "House",
      "independent_house": "Independent House",
      "independent_villa": "Independent Villa",
      "industrial_land": "Industrial Land",
      "industrial_plot": "Industrial Plot",
      "land": "Plot",
      "na_plot": "Non-Agricultural Plot",
      "paying_guest": "Paying Guest",
      "penthouse": "Penthouse",
      "pg": "PG",
      "pg_accommodation": "PG Accommodation",
      "plot": "Plot",
      "residential_plot": "Residential Plot",
      "row_house": "Row House",
      "service_apartment": "Service Apartment",
      "studio_apartment": "Studio Apartment",
      "triplex_house": "Triplex House",
      "villa": "Villa"
    },
    "under_const": "Under Construction",
    "unfurnished": "Unfurnished",
    "video_tour": "Property Video Tour",
    "view": "View",
    "view_details": "View Details",
    "visit_site": "Visit Site",
    "washrooms": "Washrooms",
    "yes": "Yes"
  },
  "property_draft": {
    "confirm_delete_desc": "Are you sure you want to delete this draft? This property and its chat progress will be removed.",
    "confirm_delete_title": "Delete draft?",
    "delete_draft": "Delete draft",
    "delete_failed": "Failed to delete draft",
    "deleted_success": "Draft deleted successfully",
    "resume": {
      "continue": "Finish last listing",
      "description": "You have an unfinished property listing. Would you like to finish where you left off or start a new one?",
      "failed": "Could not resume your listing. You can still edit the preview on the right.",
      "start_new": "Start a new listing",
      "title": "Finish your last listing?",
      "untitled": "Untitled draft"
    },
    "status": {
      "error": "Save failed",
      "saved": "Saved",
      "saving": "Saving..."
    }
  },
  "property_edit_modal": {
    "close_aria": "Close edit property dialog",
    "errors": {
      "invalid_price_type": "Invalid listing purpose.",
      "invalid_property_type": "Invalid property type. Choose Apartment, House, Villa, Commercial, Plot / Land, or PG.",
      "invalid_status": "Invalid listing status.",
      "pin_update_required": "Address changed. Update the map pin, then save.",
      "reserved_attribute_key": "That key is reserved for system fields. Use a custom name (e.g. water_supply).",
      "title_required": "Title is required",
      "update_failed": "Failed to update property. Please try again.",
      "valid_price_required": "Valid price is required"
    },
    "subtitle": "Update all details, media, and features in one place",
    "title": "Edit Property"
  },
  "property_listing": {
    "actions": {
      "post_property": "Post Property"
    },
    "alerts": {
      "choose_excel_file": "Please choose an Excel file (.xlsx).",
      "confirm_delete_property": "Are you sure you want to delete this property?",
      "delete_failed": "Failed to delete property.",
      "property_updated": "Property updated successfully!",
      "update_failed": "Failed to update property: {{error}}",
      "upgrade_failed_after_post": "Your property was posted! However, we could not automatically upgrade your role. Please contact support."
    },
    "bulk_import": {
      "ai_chat": "AI Chat",
      "btn_web_import": "Import & Review Listings on Map",
      "card_web_import": "Import from Other Website",
      "excel_file": "Excel File",
      "import_failed": "Failed to import properties.",
      "import_for_user": "Import For User",
      "invalid_file_type": "Please drop a valid Excel (.xlsx) or CSV (.csv) file.",
      "my_account": "My account",
      "page": {
        "attr_core": "Core Specifications",
        "attr_location": "Location & Map Pin",
        "attr_media": "Media & Features",
        "browse_computer": "Browse Computer",
        "change_file": "Change",
        "clear": "Clear",
        "coming_soon": "Coming Soon",
        "compatible_portals": "Compatible Real Estate Portals",
        "confirm_delete_all": "Are you sure you want to permanently delete ALL {{count}} draft listings? This action cannot be undone.",
        "confirm_delete_one": "Are you sure you want to delete this draft listing?",
        "confirm_delete_selected": "Are you sure you want to delete {{count}} selected draft listing(s)?",
        "crawl_ready": "Multi-threaded AI crawl ready",
        "crawl_review": "Crawl & Review Listings on Map",
        "crawling": "Crawling property specs & photos with AI...",
        "delete_all": "Delete All",
        "delete_all_failed": "Failed to delete all drafts.",
        "delete_draft_tooltip": "Delete draft",
        "delete_one_failed": "Failed to delete draft.",
        "delete_selected": "Delete ({{count}})",
        "delete_selected_failed": "Failed to delete some drafts.",
        "deleted_all": "Deleted all {{count}} draft(s).",
        "deleted_drafts": "Deleted {{count}} draft(s).",
        "direct_import": "Direct Import (Save as Drafts)",
        "download_paragraph_failed": "Failed to download paragraph template.",
        "download_standard_failed": "Failed to download standard template.",
        "draft_deleted": "Draft deleted.",
        "draft_missing_coords": "This draft is missing price or location coordinates. Please click \"Edit\" or \"Review on Map\" first.",
        "drafts_desc": "Review, edit on the interactive map, or batch publish pending drafts to live search.",
        "drafts_title": "Saved Draft Listings",
        "drafts_total": "{{count}} total",
        "drop_active": "Drop spreadsheet here to upload",
        "drop_here": "Drag & drop your property sheet here",
        "enter_url": "Please enter at least one valid property URL.",
        "facebook": "Facebook",
        "facebook_desc": "Import directly from Facebook Marketplace listings and real estate group posts in one click.",
        "filter_all": "All ({{count}})",
        "filter_needs_pin": "Needs Pin ({{count}})",
        "filter_pinned": "Pinned ({{count}})",
        "format_columns": "Standard Columns",
        "format_columns_desc": "Structured headers for BHK, Price, Locality",
        "format_paragraph": "AI Smart Paragraph",
        "format_paragraph_desc": "Freeform text notes parsed by AI",
        "import_finished": "Import finished: {{success}} imported, {{failed}} failed.",
        "import_first": "Import Your First Properties",
        "import_queued": "Import queued in background worker!",
        "import_success": "Successfully imported {{count}} properties!",
        "importing_urls": "Importing & parsing {{count}} listing URL(s)...",
        "insert_sample_urls": "Insert Sample URLs",
        "instagram": "Instagram",
        "instagram_desc": "Paste post or reel links. AI extracts property photos, price, BHK, and captions automatically.",
        "loading_drafts": "Loading saved drafts...",
        "location_pinned": "Location Pinned",
        "multi_portal_badge": "Multi-Portal AI Crawler",
        "need_import_now": "Need to import listings right now?",
        "need_import_now_desc": "You can upload bulk spreadsheets or import directly from web listing URLs today.",
        "needs_location_pin": "Needs Location Pin",
        "no_drafts": "No Saved Drafts",
        "no_drafts_desc": "You have no pending drafts. Incomplete properties, bulk uploads, or web imports saved as drafts will appear here.",
        "no_drafts_match": "No drafts match your current search or filter.",
        "no_valid_rows": "No valid property rows found in the sheet. Please verify your template and try again.",
        "none_ready_publish": "None of the selected drafts have a valid title/price and map pin. Please click \"Review on Map\" to place pins first.",
        "page_subtitle": "Upload spreadsheets, scrape property web links, or manage saved draft listings.",
        "parse_failed": "Failed to parse sheet with AI.",
        "parsing_desc": "Extracting BHK, pricing, amenities, room specifications, and placing initial map pins before opening the interactive review screen.",
        "parsing_title": "AI is parsing and geolocating your property listings...",
        "portal_custom": "Custom Listing Links",
        "portal_independent": "Independent Builder Sites",
        "preview_on_map": "Preview & Review on Map",
        "processing_ai": "Processing with AI...",
        "publish": "Publish",
        "publish_failed": "Failed to publish draft.",
        "publish_ready": "Publish Ready ({{count}})",
        "publish_ready_failed": "Failed to publish ready drafts. Please try again.",
        "publish_selected": "Publish Selected ({{count}})",
        "publish_tooltip": "Publish directly to live listings",
        "ready_for_parsing": "Ready for Parsing",
        "recommended_hint": "Recommended: Review on Map lets you inspect addresses, adjust coordinates, and preview specifications before publishing to live listings.",
        "refresh_drafts": "Refresh Drafts",
        "remove_file": "Remove file",
        "review_all_on_map": "Review All on Map",
        "review_on_map_n": "Review on Map ({{count}})",
        "review_pin": "Review Pin",
        "review_pin_tooltip": "Edit listing and review pin on interactive map",
        "row_error": "Row {{row}}: {{title}} — {{error}}",
        "search_drafts_placeholder": "Search drafts by title, location...",
        "select_all": "Select All ({{count}})",
        "select_format": "Select Spreadsheet Format",
        "selected_count": "{{count}} Selected",
        "social_badge": "Feature In Active Development",
        "social_desc": "Import property listings directly from your social media posts, reels, video walkthroughs, and messaging catalogs using multimodal AI extraction.",
        "social_title": "Social Media Property Import",
        "soon": "Soon",
        "supported_attributes": "Supported Attributes",
        "supports_files": "Supports Microsoft Excel (.xlsx) or CSV (.csv) up to 25 MB",
        "tab_drafts": "Saved Drafts",
        "tab_social": "Social Media",
        "tab_spreadsheet": "Spreadsheet Import",
        "tab_web_scraping": "Web Scraping",
        "template_paragraph": "Paragraph Extraction",
        "template_paragraph_desc": "Freeform text per row",
        "template_standard": "Standard Columns",
        "template_standard_desc": "Excel .xlsx template",
        "templates_desc": "Use our sample spreadsheets with mapped headers to ensure maximum accuracy during AI parsing and coordinate lookup.",
        "templates_subtitle": "Pre-configured files ready to fill",
        "templates_title": "Official Templates",
        "untitled_draft": "Untitled Draft",
        "upload_desc": "Ingest your properties in bulk via Excel or CSV. Our AI pipeline resolves addresses to exact map coordinates, parses amenities, BHK layouts, and prices automatically.",
        "upload_title": "Upload Property Spreadsheet",
        "url_extract_failed": "Could not extract properties from the provided URLs. Please ensure the URLs are accessible.",
        "url_import_failed": "Failed to import property URLs.",
        "urls_desc": "Paste property or project URLs (one per line). Our crawler extracts titles, configurations, floor plans, pricing, amenities, photos, and places pins on the map automatically.",
        "urls_detected_one": "{{count}} listing URL detected",
        "urls_detected_other": "{{count}} listing URLs detected",
        "urls_label": "Property Listing URLs (One per line)",
        "web_scraping_title": "Universal Web Scraping",
        "whatsapp": "WhatsApp Catalog",
        "whatsapp_desc": "Sync property listings directly from your WhatsApp Business catalog or forwarded message threads.",
        "youtube": "YouTube Tours",
        "youtube_desc": "AI extracts property features, floor layout descriptions, and keyframe snapshots from walkthrough videos."
      },
      "resume_in_chat_tooltip": "Resume and edit in AI Property Listing Chat",
      "select_user": "Select user",
      "subtitle": "Upload spreadsheets, scrape property web links, or manage saved draft listings.",
      "tab_web_import": "Web Import"
    },
    "descriptions": {
      "default": "Manage your properties and listings.",
      "show_all": "Explore all listings on the platform.",
      "tenant_add": "Describe your property using our AI assistant. After posting, your account will automatically upgrade to owner."
    },
    "filters": {
      "all_purposes": "All Purposes",
      "all_types": "All Types",
      "detect_location": "Detect my location",
      "property_type": "Property Type",
      "purpose": "Purpose",
      "quick_filters": "Quick Filters",
      "reset_all": "Reset All",
      "search_location": "Search Location",
      "search_location_placeholder": "City, area...",
      "search_title_placeholder": "Title..."
    },
    "headers": {
      "all_properties": "All Properties",
      "dashboard": "Dashboard",
      "list_new_property": "List New Property",
      "my_properties": "My Properties",
      "post_your_property": "Post Your Property"
    },
    "pagination": {
      "page": "Page {{page}}",
      "showing": "Showing {{shown}} of {{total}} properties"
    },
    "portfolio": {
      "managed": "Managed Portfolio",
      "owned": "Owned"
    },
    "statuses": {
      "archived": "Archived",
      "draft": "Draft",
      "rented": "Rented",
      "sold": "Sold"
    },
    "unknown_error": "Unknown error",
    "upgrade_overlay": {
      "description": "Your property was posted! We're switching you to an owner account. Just a moment…",
      "title": "Upgrading your account"
    },
    "view": {
      "grid": "Grid",
      "table": "Table"
    }
  },
  "property_listing_chat": {
    "a11y": {
      "assistant_message": "Assistant message",
      "conversation": "Property listing conversation",
      "your_message": "Your message"
    },
    "empty": {
      "description": "Start chatting to describe your property. As we collect details, they will appear here for your review.",
      "title": "No Details Yet"
    },
    "errors": {
      "chat_generic": "Sorry, I encountered an error. Please try again.",
      "hint_prefix": "💡",
      "submit_failed_prefix": "❌ Failed to submit property.",
      "submit_failed_retry": "❌ Failed to submit property. Please try again.",
      "supported_locations": "Supported locations: {{list}}"
    },
    "input": {
      "aria": "Describe your property",
      "placeholder": "Describe your property... (e.g., \"3 bedroom apartment in Hyderabad, Banjara Hills, 1500 sqft, rent 25000/month\")",
      "send_aria": "Send message",
      "send_title": "Send message"
    },
    "review": {
      "additional_details": "Additional Details",
      "amenities": "Amenities",
      "area": "Area / Locality",
      "bath_short_one": "{{count}} Bath",
      "bath_short_other": "{{count}} Bath",
      "bed_short_one": "{{count}} Bed",
      "bed_short_other": "{{count}} Bed",
      "city": "City",
      "connectivity": "Connectivity",
      "description": "Description",
      "extra_parameters": "Extra Parameters",
      "floor": "Floor:",
      "floor_of_total": "{{floor}} of {{total}}",
      "furnishing": "Furnishing:",
      "highlights": "Extra Parameters",
      "location_details": "Location Details",
      "location_unknown": "Location unknown",
      "more_images_one": "+{{count}} more",
      "more_images_other": "+{{count}} more",
      "nearby": "Nearby",
      "negotiable": "💰 Negotiable",
      "new_property": "New Property",
      "parking": "Parking:",
      "parking_spaces_one": "{{count}} spaces",
      "parking_spaces_other": "{{count}} spaces",
      "per_month": "/ month",
      "pincode": "PIN Code",
      "preview_alt": "Preview {{index}}",
      "sqft_suffix": "{{value}} sqft",
      "state_country": "State & Country",
      "street": "Street:",
      "title": "Review Property Details",
      "uploaded_images_one": "Uploaded Images ({{count}})",
      "uploaded_images_other": "Uploaded Images ({{count}})",
      "views": "Views"
    },
    "submit_listing": "Submit Listing",
    "title": "List Your Property",
    "uploaded_images_message_one": "I've uploaded {{count}} image(s)",
    "uploaded_images_message_other": "I've uploaded {{count}} image(s)",
    "voice": {
      "fallback_property_type": "property",
      "summary_complete_no_city": "I understood you want to list a {{type}}. I have all the details needed!",
      "summary_complete_with_city": "I understood you want to list a {{type}} in {{city}}. I have all the details needed!",
      "summary_incomplete_no_city": "I understood you want to list a {{type}}. Let me know if you want to add more details.",
      "summary_incomplete_with_city": "I understood you want to list a {{type}} in {{city}}. Let me know if you want to add more details."
    },
    "welcome": "Hi! I'm here to help you list your property. You can describe it in text or use voice. Tell me about your property - type, location, size, price, and any special features.",
    "widgets": {
      "bathrooms": "Bathrooms",
      "bedrooms": "Bedrooms",
      "locality_label": "area",
      "parking_spaces": "Parking Spaces"
    }
  },
  "property_listing_form": {
    "amenities_hint": "ℹ️ Lifts and balconies are automatically included in the amenities list",
    "complete_required_fields": "Complete required fields to publish:",
    "display_only_amenities": "This is display only - value is in amenities",
    "done": "Done",
    "edit_location": "Edit location",
    "edit_location_description": "Adjust the map pin to update your property coordinates.",
    "errors": {
      "failed_to_create": "Failed to create property",
      "submit_failed": "Error submitting property. Please try again.",
      "supported_locations": "Supported locations include"
    },
    "extracted_fields": "LetMeIn AI extracted {{count}} of {{total}} fields",
    "labels": {
      "additional_details": "Additional details",
      "age_of_construction": "Age of Construction",
      "apartment_name": "Apartment Name",
      "area": "Area",
      "area_locality": "Area / Locality",
      "area_type": "Area Type",
      "assured_returns": "Assured Returns",
      "available_for": "Available for",
      "available_from": "Available from",
      "available_services": "Available Services",
      "balconies": "Balconies",
      "bathrooms": "Bathrooms",
      "bedrooms": "Bedrooms",
      "booking_token_amount": "Booking / Token Amount",
      "boundary_wall": "Boundary Wall",
      "car_spaces_count": "Car Parking Slots:",
      "ceiling_height": "Ceiling Height",
      "city": "City",
      "commercial_subtype": "Commercial type",
      "common_area_amenities": "Common area amenities",
      "connectivity": "Connectivity",
      "corner_plot": "Corner Plot",
      "corner_shop": "Corner Shop / Unit",
      "country": "Country",
      "currently_leased_out": "Currently Leased Out",
      "entrance_width": "Entrance Width",
      "expected_price": "Expected Rent/Price",
      "extra_pantry": "Pantry",
      "facing": "Facing",
      "floor_number": "Floor Number",
      "floors_allowed_for_construction": "Floors Allowed",
      "food_available": "Food available",
      "furnishing": "Furnishing",
      "gate_closing_time": "Gate closing time",
      "ideal_for_businesses": "Ideal For",
      "intent": "Intent",
      "land_zoning": "Land zoning",
      "lifts": "Lifts/Elevators",
      "listing_subtype": "Property sub-type",
      "loading_unloading_access": "Loading / Unloading",
      "location": "Location",
      "maintenance_charges": "Maintenance Charges",
      "nearby_businesses": "Nearby Businesses",
      "nearby_places": "Nearby Places",
      "open_sides": "Open Sides",
      "parking": "Parking Facility",
      "parking_spaces": "Parking Spaces",
      "personal_washroom": "Personal washroom",
      "pg_name": "PG name",
      "pg_present_in": "PG is present in",
      "pg_rules": "PG rules",
      "pg_usps": "Unique selling points",
      "pincode": "Pincode",
      "plot_breadth": "Plot Breadth (ft)",
      "plot_length": "Plot Length (ft)",
      "plot_subtype": "Plot type",
      "possession_status": "Possession status",
      "power_supply": "Power Supply",
      "preferred_tenants": "Preferred Tenants",
      "property_amenities": "Property Amenities",
      "property_name": "Property / Project Name",
      "property_type": "Property Type",
      "road_width": "Road Width",
      "road_width_facing_plot": "Road Facing Plot",
      "room_facilities_short": "room facilities",
      "room_sharing": "Room sharing",
      "security_deposit": "Security deposit",
      "state": "State",
      "street_address": "Street address",
      "tenant_preference": "Tenant preference",
      "title": "Title",
      "total_floors": "Total floors",
      "truck_accessibility": "Truck Accessibility",
      "washroom_available": "Washroom Available",
      "washroom_count": "Washroom Count"
    },
    "listing_progress": "Listing Progress",
    "map_pin_needed_desc": "Click here to confirm the exact property location on the map.",
    "map_pin_needed_title": "Map pin required to publish",
    "negotiable_price": "💰 Negotiable Price",
    "pg": {
      "anyone": "Anyone",
      "available_floors": "Available Floors",
      "beds_per_room": "Beds per room",
      "boys": "Boys",
      "girls": "Girls",
      "rent_per_bed_short": "Rent/bed",
      "rooms": "Rooms",
      "sharing_double": "Double",
      "sharing_four": "Four sharing",
      "sharing_single": "Single",
      "sharing_triple": "Triple"
    },
    "pg_section": "PG details (required)",
    "pin_map_action": "Pin Map",
    "pincode_resolve_failed": "Could not resolve that pincode for the selected city.",
    "placeholders": {
      "age_of_construction": "Select",
      "apartment_name": "e.g. Ajmera Enclave",
      "area": "e.g. 2250",
      "area_locality": "e.g. South Bank",
      "area_type": "e.g. Carpet, Built-up",
      "available_for": "Select",
      "booking_token_amount": "e.g. 100000",
      "city": "e.g. Brisbane",
      "connectivity": "e.g. Metro Station, Bus Stop",
      "country": "e.g. Australia",
      "facing": "e.g. East",
      "floor_number": "e.g. 15",
      "food_available": "Select",
      "furnishing": "e.g. Semi-furnished",
      "highlights": "Add extras (corner unit, false ceiling, …)",
      "intent": "Sell/Rent",
      "maintenance_amount": "e.g. 5000",
      "maintenance_frequency": "Monthly",
      "nearby_places": "e.g. School, Hospital, Mall",
      "number_example_2": "e.g. 2",
      "number_example_3": "e.g. 3",
      "pg_name": "e.g. Sri Sai PG",
      "pg_present_in": "Select",
      "pincode": "e.g. 500032",
      "price_example": "e.g. 80,000",
      "property_name": "e.g. Green Valley Farmhouse",
      "room_sharing": "Select sharing",
      "security_deposit": "e.g. 10000 or 0",
      "select_property_type": "Select property type",
      "state": "e.g. Queensland",
      "street_address": "Building name, street, landmark…",
      "street_address_unconfirmed": "Confirm address in the chat widget to fill street address…",
      "title": "e.g. 3 BHK Luxury Flat",
      "total_floors": "e.g. 10"
    },
    "posting": "Publishing...",
    "preferred_tenants_hint": "Select who you prefer to rent to (also asked in chat for rent listings).",
    "preview": {
      "connectivity": "Connectivity Preview",
      "nearby_places": "Nearby Places Preview"
    },
    "set_location_pin": "Set map location *",
    "status": {
      "in_progress": "In Progress",
      "ready_to_list": "Ready to List"
    },
    "submit": "Publish",
    "title": "Property Listing Preview",
    "units": {
      "acres": "Acres",
      "bigha": "Bigha",
      "cents": "Cents",
      "guntas": "Guntas",
      "marla": "Marla",
      "sqft": "Sq. ft.",
      "sqyd": "Sq. yd."
    },
    "validation": {
      "incomplete_sharing": "Please complete all sharing details",
      "missing_area": "Area / Locality is required",
      "missing_available_for": "Tenant preference is required",
      "missing_deposit": "Valid security deposit is required",
      "missing_intent": "Listing intent (Rent / Sell) is required",
      "missing_map_pin": "Map location pin is required",
      "missing_pg_name": "PG name is required",
      "missing_pg_present_in": "Building type is required",
      "missing_price": "Valid price/rent is required",
      "missing_room_sharing": "Room sharing option is required",
      "missing_type": "Property type is required"
    }
  },
  "property_manager_details": {
    "actions": {
      "back": "Back",
      "back_home": "Back to Home",
      "contact_agent": "Contact Agent",
      "view_details": "View Details"
    },
    "badges": {
      "preferred": "Preferred"
    },
    "empty": {
      "no_active_listings": "No active listings",
      "no_active_listings_desc": "This agent currently has no public properties listed."
    },
    "errors": {
      "load_failed": "Failed to load manager details",
      "not_found": "Manager not found"
    },
    "fallback": {
      "agent": "Agent",
      "city": "Hyderabad",
      "deal_types": {
        "rent_lease": "Rent/Lease",
        "sale": "Sale"
      },
      "independent_agent": "Independent Agent",
      "initials": "PM"
    },
    "labels": {
      "baths": "Baths",
      "beds": "Beds",
      "company": "Company",
      "member_since": "Member since",
      "no_images": "No Images",
      "sqft": "Sqft"
    },
    "loading_profile": "Loading profile...",
    "results_count_one": "{{count}} Results",
    "results_count_other": "{{count}} Results",
    "sections": {
      "active_listings": "Active Listings",
      "active_listings_desc": "Discover premium properties managed by {{name}}",
      "operating_areas": "Operating Areas",
      "specializations": "Specializations"
    },
    "stats": {
      "buyers_served": "Buyers Served",
      "deals_closed": "Deals Closed",
      "for_rent": "Properties For Rent",
      "for_sale": "Properties For Sale"
    }
  },
  "rbac": {
    "matrix": {
      "cancel_btn": "Cancel",
      "edit_btn": "Edit Permissions",
      "role_column": "Role",
      "save_btn": "Save Changes",
      "title": "Permission Matrix"
    },
    "roles": {
      "create_btn": "Create Role",
      "create_dialog": {
        "description": "Create a new role and assign permissions to it.",
        "title": "Create New Role"
      },
      "description": "Manage roles and their permissions.",
      "search_placeholder": "Search roles...",
      "title": "Roles"
    }
  },
  "redisInsight": {
    "appCache": "App cache settings",
    "colDesc": "Description",
    "colPrefix": "Prefix",
    "colTtl": "Typical TTL",
    "colType": "Type",
    "connection": "Connection",
    "connectionDesc": "From REDIS_URL (password not shown)",
    "error": "Error",
    "key": "Key",
    "keyDetails": "TYPE, TTL, and value preview",
    "match": "MATCH pattern",
    "next": "Next page",
    "nextCursor": "Next cursor",
    "noKeys": "No keys in this batch. Try another pattern or Next if cursor is non-zero.",
    "prefixTableDesc": "Use these patterns in Browse → MATCH filter. See documentation/REDIS.md for details.",
    "prefixTableTitle": "Prefixes used by this application",
    "refresh": "Refresh overview",
    "runScan": "Scan",
    "scanComplete": "iteration complete",
    "scanDesc": "Non-blocking iteration. Large databases may require multiple pages.",
    "scanTitle": "SCAN keys",
    "sensitiveBody": "Keys may contain client IPs, geolocation, and cached transcripts. Do not share screenshots publicly.",
    "sensitiveTitle": "Sensitive data",
    "stats": "Statistics",
    "subtitle": "Super admin only — read-only view of cache, rate limits, and app Redis keys.",
    "tabBrowse": "Browse keys",
    "tabOverview": "Overview",
    "tabPrefixes": "Key families",
    "title": "Redis Insight",
    "view": "View"
  },
  "reports": {
    "access_logs_desc": "Track system-wide access logs",
    "bulk_export": "Bulk Export",
    "categories": {
      "analytics": "Analytics",
      "billing": "Billing",
      "growth": "Growth",
      "management": "Management",
      "messages": "Messages",
      "security": "Security"
    },
    "coming_soon_message": "The comprehensive reporting module is currently under development. Soon you will be able to generate custom reports, schedule automated exports, and analyze deep performance metrics directly from this dashboard.",
    "coming_soon_title": "Coming Soon: Advanced Reporting",
    "compliance_log_desc": "Full compliance and status log",
    "demographic_desc": "Platform user demographic data",
    "description_superadmin": "Access high-level platform audits, revenue streams, and system logs.",
    "description_user": "Generate, view, and export detailed system and property reports.",
    "executive_desc": "One-page executive summary",
    "filter": "Filter",
    "financial_desc": "Financial performance overview",
    "generate_new": "Generate New",
    "items": {
      "compliance_check": {
        "description": "Audit status of all registered business entities.",
        "name": "Organization Compliance Check"
      },
      "consolidated_revenue": {
        "description": "Stripe transaction volume and subscription MRR breakdown.",
        "name": "Consolidated Revenue Report"
      },
      "growth_analysis": {
        "description": "Year-over-year growth metrics for users and organizations.",
        "name": "Platform Growth Analysis - Q1 2026"
      },
      "maintenance_report": {
        "description": "Status update on all ongoing and completed maintenance tasks.",
        "name": "Property Maintenance Report"
      },
      "monthly_review": {
        "description": "Comprehensive overview of property performance, traffic, and leads.",
        "name": "Monthly Performance Review - Jan 2026"
      },
      "revenue_export": {
        "description": "Stripe transaction history and subscription status details.",
        "name": "Revenue & Subscription Export"
      },
      "security_audit": {
        "description": "Complete trace of access logs and sensitive system changes.",
        "name": "Security Audit & System Logs"
      },
      "tenant_log": {
        "description": "Detailed breakdown of all messages and inquiries from prospective tenants.",
        "name": "Tenant Interaction Log"
      }
    },
    "load_more": "Load More Reports",
    "property_audit": "Property Audit",
    "raw_export_desc": "Export all data to RAW format",
    "recent_reports": "Recent Reports",
    "reports_list_desc": "A list of your recently generated data exports.",
    "revenue_matrix": "Revenue Matrix",
    "sample_data_badge": "Demo Only - Sample Data",
    "sample_file_type": "{{type}} (Sample)",
    "security_logs": "Security Logs",
    "title_superadmin": "Platform Intelligence",
    "title_user": "System Reports",
    "user_analytics": "User Analytics",
    "view": "View",
    "visual_summary": "Visual Summary"
  },
  "reset_password": {
    "actions": {
      "reset": "Reset password",
      "resetting": "Resetting..."
    },
    "description": "Enter your new password below.",
    "errors": {
      "expired_link": "Invalid or expired reset link. Please request a new one.",
      "invalid_token": "Invalid or missing token.",
      "min_length": "Password must be at least 8 characters.",
      "password_mismatch": "Passwords do not match."
    },
    "fields": {
      "confirm_password_label": "Confirm new password",
      "confirm_password_placeholder": "Re-enter new password",
      "new_password_label": "New password",
      "new_password_placeholder": "Enter new password"
    },
    "success": {
      "redirecting": "Redirecting to login...",
      "title": "Your password has been reset!"
    },
    "title": "Reset your password"
  },
  "roles": {
    "admin": "Admin",
    "individual": "Individual",
    "org_admin": "Organization Admin",
    "org_user": "Organization User",
    "owner": "Owner",
    "property_manager": "Property Manager",
    "super_admin": "Super Admin",
    "tenant": "Tenant"
  },
  "search": {
    "all_results_desc": "{{shown}} of {{total}} properties shown",
    "all_results_title": "All search results",
    "featured_listing": "Featured",
    "load_more_failed": "Could not load more properties. Please try again.",
    "loading_more": "Loading…",
    "matches_found_one": "Match found",
    "matches_found_other": "Matches found",
    "modify_btn": "Modify Search",
    "modify_placeholder": "Describe how you want to refine your search…",
    "more_matches": "More matches",
    "show_more": "Show more",
    "sponsored": "Sponsored",
    "view_all_results_one": "View all {{count}} results",
    "view_all_results_other": "View all {{count}} results"
  },
  "search_chips": {
    "clear_all": "Clear All",
    "within_km": "Within {{n}}km",
    "within_m": "Within {{n}}m"
  },
  "settings": {
    "choose_language": "Choose the language for your experience",
    "features": {
      "controls": {
        "description": "Toggle features on or off for all users",
        "title": "Feature Controls"
      },
      "description": "Enable or disable application features",
      "items": {
        "aadhaar_verification": {
          "description": "Enable Aadhaar OTP verification for users",
          "title": "Aadhaar Verification"
        },
        "ai_chat": {
          "description": "Enable AI-powered chat assistant",
          "title": "AI Chat"
        },
        "geo_search": {
          "description": "PostGIS radius search, map results, and /assistant",
          "title": "Geo map search"
        },
        "property_comparison": {
          "description": "Allow users to compare multiple properties",
          "title": "Property Comparison"
        },
        "toon_format": {
          "description": "Enable TOON format responses from the LLM",
          "title": "TOON Format for LLM"
        },
        "voice_search": {
          "description": "Enable voice-based property search",
          "title": "Voice Search"
        }
      },
      "storage": {
        "firestore": {
          "db_info": "Using Firestore database",
          "description": "Configure where token usage and activity logs are stored when using Firestore.",
          "status_label": "Firestore connection",
          "test_btn": "Test connection",
          "title": "Firebase / Firestore storage"
        }
      },
      "title": "Feature Flags"
    },
    "firebase": {
      "description": "Firestore connection and storage backend (Database vs Firestore) for token usage and activity logs.",
      "test_to_verify": "Test connection to verify Firestore is configured."
    },
    "general": {
      "description": "Configure basic application settings",
      "site_config": {
        "contact_email": "Contact Email",
        "contact_email_placeholder": "contact@example.com",
        "description": "Basic information about your application",
        "max_image_upload_mb": "Max Image Upload Size (MB)",
        "max_image_upload_mb_description": "Maximum size in megabytes for a single uploaded property image.",
        "max_media_limit": "Max Media per Property Listing (Photos & Video Tours)",
        "max_media_limit_description": "Maximum total media (photos and video tours combined) allowed per property listing.",
        "max_scraper_video_limit": "Max Scraped Videos per Property (Web Scraping)",
        "max_scraper_video_limit_description": "Maximum number of video tours to scrape per listing.",
        "max_video_upload_mb": "Max Video Upload Size (MB)",
        "max_video_upload_mb_description": "Maximum size in megabytes for a single uploaded property video.",
        "site_description": "Site Description",
        "site_description_placeholder": "AI-powered real estate platform",
        "site_name": "Site Name",
        "site_name_placeholder": "My Real Estate App",
        "title": "Site Configuration"
      },
      "title": "General Settings"
    },
    "interface_language": "Interface Language",
    "language": "Language",
    "language_preferences": "Language Preferences",
    "language_saved": "Language preferences updated successfully",
    "languages": "Languages",
    "media": {
      "description": "Configure property media limits, video upload sizes, and web scraper settings",
      "subtitle": "Control photo counts, video tour limits, and maximum file upload sizes per listing",
      "title": "Media & Video Upload Limits"
    },
    "mobile": {
      "open_sections": "Open settings sections"
    },
    "no_permission": "You do not have permission to access system settings. Only administrators can manage system settings.",
    "save": "Save Changes",
    "sections": {
      "advanced": "Advanced",
      "api": "API Config",
      "auth": "Authentication",
      "email": "Email Config",
      "features": "Feature Flags",
      "firebase": "Firebase",
      "general": "General",
      "media": "Media & Uploads",
      "payment": "Payment"
    },
    "select_from_available": "Select from the available languages",
    "select_language": "Select your preferred language",
    "sidebar": {
      "description": "Manage global application settings",
      "title": "System Settings"
    }
  },
  "sidebar": {
    "activity_logs": "Activity Logs",
    "administration": "Administration",
    "all_properties": "All Properties",
    "all_subscriptions": "All Subscriptions",
    "analytics": "Analytics",
    "analytics_reports": "Analytics & Reports",
    "api_usage": "API Usage",
    "auth_matrix": "Auth Matrix",
    "brokerage_hub": "Brokerage Hub",
    "dashboard": "Dashboard",
    "feedback": "Feedback",
    "google_maps_usage": "Maps & Places cost",
    "help_support": "Help & Support",
    "import_properties": "Import Properties",
    "list_my_properties": "List my properties",
    "list_properties": "List New Property",
    "logout": "Logout",
    "manage_plans": "Manage Plans",
    "manage_roles": "Manage Roles",
    "messages": "Messages",
    "my_favourites": "My Favourites",
    "my_leases": "My Leases",
    "my_properties": "My Properties",
    "my_subscription": "My Subscription",
    "org_properties": "Org Properties",
    "org_users": "Org Users",
    "organizations": "Builders",
    "owner": "Owner",
    "profile": "Profile",
    "property_search": "Property Search",
    "redis_insight": "Redis Insight",
    "reports": "Reports",
    "revenue": "Revenue",
    "reviews": "Reviews",
    "roles_perms": "Roles & Perms",
    "settings": "Settings",
    "subscription": "Subscription",
    "tenant": "Tenant",
    "tenants": "Tenants & Inquiries",
    "token_usage": "Token usage",
    "transactions": "Transactions",
    "usage_billing": "Usage & Billing",
    "users": "Users"
  },
  "simple_test": {
    "button": "Click Me",
    "description": "Detect and translate this minimal page.",
    "title": "Simple Translation Test"
  },
  "single_phase": "",
  "subscription": {
    "active": "Active",
    "auto_renewal": "Auto-renewal",
    "billing_info": "Billing Information",
    "cancel_btn": "Cancel Subscription",
    "cancel_desc": "Are you sure you want to cancel your subscription? This will downgrade you to the free plan at the end of your billing cycle.",
    "change_btn": "Change Plan",
    "choose_plan": {
      "back_to_manage": "Back to Manage Plans",
      "back_to_sub": "Back to My Subscription",
      "forever": "Forever",
      "monthly": "Monthly",
      "regular_desc": "Choose your main subscription plan",
      "regular_plans": "Regular Plans",
      "subscribe": "Subscribe",
      "subtitle": "Select the perfect plan for your needs.",
      "title": "Choose Your Plan",
      "yearly": "Yearly"
    },
    "confirm_cancel": "Confirm Cancellation",
    "current_plan": "Current Plan",
    "disabled": "Disabled",
    "enabled": "Enabled",
    "free_tier": "Free Tier",
    "inactive": "Inactive",
    "keep_btn": "Keep Subscription",
    "next_billing": "Next Billing Date",
    "org_plan_desc": "Your subscription is provided by your organization.",
    "plan_details": "Plan Details",
    "status": "Status",
    "title": "Your Subscription",
    "upgrade_btn": "Upgrade Plan",
    "using_org_plan": "Using Organization Plan"
  },
  "terms_of_service": {
    "contact": {
      "prefix": "If you have any questions about these Terms, please contact us at"
    },
    "last_updated": "Last updated: January 30, 2026",
    "sections": {
      "accounts": {
        "body": "When you create an account with us, you must provide information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service.",
        "title": "3. User Accounts"
      },
      "agreement": {
        "body": "By accessing or using LetMeIn AI, you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access the service.",
        "title": "1. Agreement to Terms"
      },
      "changes": {
        "body": "We reserve the right, at our sole discretion, to modify or replace these Terms at any time. By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms.",
        "title": "7. Changes to Terms"
      },
      "description": {
        "body": "LetMeIn AI provides a platform for property owners to list their properties and for users to discover and book various types of accommodations, including hotel rooms, hostel beds, and coliving spaces.",
        "title": "2. Description of Service"
      },
      "liability": {
        "body": "In no event shall LetMeIn AI, nor its directors, employees, or partners, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, or use.",
        "title": "6. Limitation of Liability"
      },
      "listings": {
        "body": "Owners and managers are responsible for the accuracy and legality of the property listings they post. LetMeIn AI does not guarantee the existence, quality, or safety of listed properties.",
        "title": "4. Property Listings"
      },
      "prohibited": {
        "body": "You agree not to engage in any of the following prohibited activities:",
        "items": {
          "automation": "Using any automated system, including \"robots,\" \"spiders,\" or \"offline readers\" to access the Service.",
          "copying": "Copying, distributing, or disclosing any part of the Service in any medium.",
          "interference": "Attempting to interfere with, compromise the system integrity or security, or decipher any transmissions to or from the servers running the Service."
        },
        "title": "5. Prohibited Activities"
      }
    },
    "title": "Terms of Service"
  },
  "three_phase": "",
  "token_usage": {
    "by_endpoint": "By Endpoint",
    "by_member": "By Member",
    "calls": "Calls",
    "days": "Days",
    "description": "View token usage, cost by provider and endpoint, and export CSV. Admin only.",
    "endpoint": "Endpoint",
    "export_csv": "Export token usage CSV",
    "export_ledger_csv": "Export ledger CSV",
    "member": "Member",
    "no_org_data": "No organization usage data found. Load the Summary tab first.",
    "org_name": "Organization",
    "org_overview": "Organization Overview",
    "organization": "Organization",
    "summary": {
      "card_description": "Total tokens and cost by provider and endpoint.",
      "card_title": "Summary"
    },
    "tabs": {
      "by_format": "By Format",
      "by_org": "By Organization",
      "by_user": "By User",
      "daily": "Daily",
      "recent": "Recent",
      "summary": "Summary"
    },
    "title": "Token / LLM Usage",
    "tokens": "Tokens",
    "total_calls": "Total Calls",
    "total_tokens": "Total Tokens"
  },
  "topup_page": {
    "actions": {
      "change_amount": "Change amount",
      "continue_to_payment": "Continue to payment",
      "pay_with_razorpay": "Pay with Razorpay"
    },
    "amount_help": "{{description}} Min {{min}}, max {{max}}.",
    "amount_label": "Amount (USD)",
    "amount_label_inr": "Amount (INR)",
    "amount_placeholder": "e.g. 20",
    "amount_placeholder_inr": "e.g. 500",
    "checkout": {
      "amount_label": "Amount",
      "description": "Enter your payment details to add {{amount}} to {{target}}.",
      "loading_form": "Loading payment form...",
      "pay_amount": "Pay {{amount}}",
      "processing": "Processing..."
    },
    "description": {
      "org": "Credits will be added to your organization's shared wallet, available to all team members.",
      "personal": "Credits will be added to your personal balance."
    },
    "errors": {
      "payment_failed": "Payment failed",
      "razorpay_load_failed": "Failed to load Razorpay checkout",
      "start_payment_failed": "Failed to start payment"
    },
    "loading": "Loading...",
    "org_notice_amount": {
      "prefix": "These credits will be added to the",
      "suffix": "and consumed by all team members.",
      "wallet": "organization's shared wallet"
    },
    "org_notice_checkout": {
      "prefix": "Topping up the",
      "suffix": "all members can use these credits.",
      "wallet": "organization wallet"
    },
    "razorpay_description": "Add credits to your wallet",
    "razorpay_notice": "You will pay via Razorpay (UPI, cards, netbanking). Credits are added after payment.",
    "targets": {
      "org_wallet": "the organization wallet",
      "personal_balance": "your balance"
    },
    "title": {
      "org": "Add Credits to Organization",
      "personal": "Add Credits"
    }
  },
  "transactions": {
    "description": "View and manage all payment transactions.",
    "headers": {
      "credited": "Credited",
      "download": "Download Invoice",
      "item": "Item",
      "paid": "Paid",
      "payment_method": "Payment Method",
      "transaction_id": "Transaction ID",
      "type": "Type",
      "user": "User"
    },
    "items": {
      "org_topup": "Org wallet ({{gateway}})",
      "personal_topup": "Personal wallet ({{gateway}})"
    },
    "search_placeholder": "Search transactions...",
    "table": {
      "description": "A list of all payment transactions in your system.",
      "title": "All Transactions"
    },
    "title": "Transactions",
    "types": {
      "other": "Other",
      "plan": "Plan",
      "topup": "Credit top-up"
    }
  },
  "translationDemo": {
    "actions": {
      "decrement": "",
      "increment": "",
      "loading": "",
      "reset": "",
      "submit": ""
    },
    "badge": "",
    "bestPractices": {
      "tip1": "",
      "tip2": "",
      "tip3": "",
      "tip4": ""
    },
    "counter": {
      "label": "",
      "message_one": "",
      "message_other": ""
    },
    "description": "",
    "examples": {
      "greeting": {
        "label": "",
        "message": ""
      },
      "simple": {
        "label": "",
        "text": ""
      }
    },
    "footer": {
      "text": ""
    },
    "notifications": {
      "error": "",
      "info": "",
      "success": ""
    },
    "sections": {
      "basic": {
        "description": "",
        "title": ""
      },
      "bestPractices": {
        "description": "",
        "title": ""
      },
      "conditional": {
        "description": "",
        "title": ""
      },
      "pluralization": {
        "description": "",
        "title": ""
      },
      "statuses": {
        "description": "",
        "title": ""
      }
    },
    "status": {
      "error": "",
      "success": ""
    },
    "title": ""
  },
  "user_roles_page": {
    "access_denied": {
      "description": "You don't have permission to view user role management.",
      "title": "Access Denied"
    },
    "actions": {
      "assign_role": "Assign Role"
    },
    "alerts": {
      "assign_failed": "Failed to assign role.",
      "role_assigned": "Role assigned successfully!",
      "select_user_role": "Please select both a user and a role."
    },
    "dialog": {
      "global_role": "Global Role",
      "organization_label": "Organization (Optional)",
      "organization_placeholder": "Global Role",
      "role_label": "Role",
      "role_placeholder": "Select a role",
      "title": "Assign Role to User",
      "user_label": "User",
      "user_placeholder": "Select a user"
    },
    "loading": "Loading user roles...",
    "search_placeholder": "Search users...",
    "showing_users_one": "Showing {{count}} users with role assignments",
    "showing_users_other": "Showing {{count}} users with role assignments",
    "subtitle": "Assign and manage roles for users",
    "table": {
      "name": "Name",
      "roles": "Roles",
      "status": "Status"
    },
    "title": "User Role Management"
  },
  "validation": {
    "accept_terms": "You must accept the terms and conditions",
    "billing_country_required": "Select your country of residence",
    "city_required_signup": "City is required",
    "invalid_email": "Please enter a valid email address",
    "org_name_min": "Organization name must be at least 4 characters",
    "password_complexity": "Password must contain at least one uppercase letter, one lowercase letter, and one number",
    "password_min": "Password must be at least 8 characters",
    "passwords_mismatch": "Passwords don't match",
    "phone_country": "Select a country code",
    "username_min": "Username must be at least 2 characters"
  },
  "verify_email": {
    "actions": {
      "go_to_login": "Go to Login"
    },
    "descriptions": {
      "error": "There was a problem verifying your email.",
      "pending": "Please wait while we verify your email.",
      "success": "Your email has been verified! Redirecting to login..."
    },
    "messages": {
      "invalid_token": "Invalid or missing verification token.",
      "verification_failed": "Verification failed. The link may be invalid or expired.",
      "verified": "Your email has been verified!",
      "verifying": "Verifying your email..."
    },
    "title": "Email Verification"
  },
  "voice": {
    "failed_start": "Failed to start recording",
    "hold_to_speak": "Hold to speak, tap to toggle",
    "live_connect_failed": "Live voice connection failed. Try again.",
    "mic_denied": "Microphone access denied",
    "no_mic": "No microphone found",
    "no_speech": "No speech detected",
    "not_supported": "Voice input not supported in this browser",
    "permission_denied": "Microphone permission denied",
    "recognition_error": "Speech recognition error",
    "stop_recording": "Stop recording",
    "transcribing": "Transcribing audio...",
    "transcribing_btn": "Transcribing...",
    "transcription_failed": "Transcription failed"
  }
}
